// import { CheckCircleFilled } from "@ant-design/icons";
// import { Progress, Rate, Spin, Table } from "antd";
// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import { Alert, Form } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import { vasthuUrl } from "../component/Api";
// import BillDeskPay from "../component/BillDeskPay";

// const DIRECTION_OPTIONS = [
//   { value: "north", label: "North" },
//   { value: "south", label: "South" },
//   { value: "east", label: "East" },
//   { value: "west", label: "West" },
//   { value: "northeast", label: "North-East (Ishan)" },
//   { value: "northwest", label: "North-West (Vayavya)" },
//   { value: "southeast", label: "South-East (Agneya)" },
//   { value: "southwest", label: "South-West (Nairutya)" },
// ];

// const LAGNA_OPTIONS = [
//   { value: "mesha", label: "Mesha (Aries)" },
//   { value: "vrishabha", label: "Vrishabha (Taurus)" },
//   { value: "mithuna", label: "Mithuna (Gemini)" },
//   { value: "karka", label: "Karka (Cancer)" },
//   { value: "simha", label: "Simha (Leo)" },
//   { value: "kanya", label: "Kanya (Virgo)" },
//   { value: "tula", label: "Tula (Libra)" },
//   { value: "vrishchika", label: "Vrishchika (Scorpio)" },
//   { value: "dhanu", label: "Dhanu (Sagittarius)" },
//   { value: "makara", label: "Makara (Capricorn)" },
//   { value: "kumbha", label: "Kumbha (Aquarius)" },
//   { value: "meena", label: "Meena (Pisces)" },
// ];

// const LEVEL_OPTIONS = [
//   { value: "low", label: "USR.VSH.LVLTAB.DD.ITM.LW" },
//   { value: "high", label: "USR.VSH.LVLTAB.DD.ITM.HG" },
// ];

// const NAME_REGEX = /^[a-zA-Z\s.'-]*$/;
// const POSITIVE_NUMBER_REGEX = /^\d*\.?\d*$/;

// function validateName(value) {
//   if (!value) return "";
//   if (!NAME_REGEX.test(value)) return "Numbers/special characters not allowed";
//   return "";
// }

// function validatePositiveNumber(value) {
//   if (!value) return "";
//   if (!POSITIVE_NUMBER_REGEX.test(value)) return "Numbers only";
//   if (parseFloat(value) <= 0) return "Value must be greater than 0";
//   return "";
// }

// function getFloorCountFromLabel(label = "") {
//   const gMatch = label.match(/G\+(\d+)/i);
//   if (gMatch) return parseInt(gMatch[1], 10) + 1;
//   const floorsMatch = label.match(/(\d+)\s*floors?/i);
//   if (floorsMatch) return parseInt(floorsMatch[1], 10);
//   if (/single/i.test(label)) return 1;
//   return 1;
// }

// // function deriveLevelValues(details) {
// //   const levels = {
// //     southLevel: 0,
// //     northLevel: 0,
// //     southWestLevel: 0,
// //     northEastLevel: 0,
// //     westLevel: 0,
// //     eastLevel: 0,
// //   };
// //   if (details?.southNorth === "south") levels.southLevel = 1;
// //   if (details?.southNorth === "north") levels.northLevel = 1;
// //   if (details?.southwestNortheast === "southwest") levels.southWestLevel = 1;
// //   if (details?.southwestNortheast === "northeast") levels.northEastLevel = 1;
// //   if (details?.westEast === "west") levels.westLevel = 1;
// //   if (details?.westEast === "east") levels.eastLevel = 1;
// //   return levels;
// // }

// function deriveLevelValues(details) {
//   const toBit = (v) => (v === "high" ? 1 : 0);
//   return {
//     southLevel: toBit(details?.southLevel),
//     northLevel: toBit(details?.northLevel),
//     southWestLevel: toBit(details?.southWestLevel),
//     northEastLevel: toBit(details?.northEastLevel),
//     westLevel: toBit(details?.westLevel),
//     eastLevel: toBit(details?.eastLevel),
//   };
// }

// function formatElementName(name = "") {
//   return name
//     .toLowerCase()
//     .split(" ")
//     .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
//     .join(" ");
// }

// const LAGNAS = LAGNA_OPTIONS.map((o) => o.label);

// /* ── tiny style tokens (inline, so this file has zero external CSS needs) ── */
// const C = {
//   maroon: "#7B1E1E",
//   maroonLight: "#9B2E2E",
//   gold: "#C8860A",
//   goldLight: "#D9960F",
//   cream: "#FDF8F0",
//   creamCard: "#FFF8EE",
//   sand: "#F5EFE6",
//   border: "#E8D8C4",
//   taupe: "#8B6A4F",
//   ink: "#2D1A0E",
//   placeholder: "#C4A882",
// };
// const display = { fontFamily: "'Cormorant Garamond', 'Noto Serif', serif" };

// /* ── shared bits ─────────────────────────────────────────────────────── */
// function OmSymbol({ size = 32 }) {
//   return (
//     <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
//       <text
//         x="50%"
//         y="56%"
//         textAnchor="middle"
//         fontSize={size * 0.8}
//         fontFamily="Noto Serif"
//         fill={C.gold}
//         dominantBaseline="middle"
//       >
//         ॐ
//       </text>
//     </svg>
//   );
// }

// // Reusable real-photo block. Replaces the old inline SVG "Illustration"
// // components (Door/Window/Rooms/Leveling/Misc) used across the report tabs
// // and overview summary cards. Drop the matching PNG into /public/images/.
// function SectionImage({ src, alt, size = 150 }) {
//   return (
//     <div
//       style={{
//         width: size,
//         height: size,
//         borderRadius: 14,
//         overflow: "hidden",
//         flexShrink: 0,
//         background: "#F6EEE2",
//       }}
//     >
//       <img
//         src={src}
//         alt={alt}
//         style={{
//           width: "100%",
//           height: "100%",
//           objectFit: "cover",
//           display: "block",
//         }}
//       />
//     </div>
//   );
// }

// function VastuCard({ children, style = {} }) {
//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: `1px solid ${C.border}`,
//         borderRadius: 18,
//         boxShadow: "0 8px 24px rgba(123,30,30,0.06)",
//         padding: "1.5rem",
//         ...style,
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function GoldHeading({ children, sub }) {
//   return (
//     <div className="text-center mb-4">
//       <h2
//         style={{
//           ...display,
//           fontWeight: 700,
//           color: C.maroon,
//           fontSize: "1.9rem",
//         }}
//       >
//         {children}
//       </h2>
//       {sub && (
//         <p className="small mb-0" style={{ color: C.taupe }}>
//           {sub}
//         </p>
//       )}
//     </div>
//   );
// }

// function FieldInput({
//   label,
//   value,
//   onChange,
//   type = "text",
//   placeholder = "",
//   required = false,
//   helpText = "",
//   error = "",
// }) {
//   const { t } = useTranslation();

//   return (
//     <Form.Group className="mb-3">
//       <Form.Label
//         style={{
//           fontSize: 12,
//           fontWeight: 700,
//           color: C.maroon,
//           textTransform: "uppercase",
//           letterSpacing: "0.04em",
//         }}
//       >
//         {t(label)} {required && <span style={{ color: C.gold }}>*</span>}
//       </Form.Label>
//       <Form.Control
//         type={type}
//         value={value}
//         placeholder={t(placeholder)}
//         isInvalid={!!error}
//         onChange={(e) => {
//           let val = e.target.value;

//           // Convert HH:mm → HH:mm:ss
//           if (type === "time" && val && val.length === 5) {
//             val = `${val}:00`;
//           }

//           onChange(val);
//         }}
//         style={{
//           background: C.cream,
//           border: `1px solid ${error ? "#D64545" : C.border}`,
//           borderRadius: 10,
//           padding: "0.6rem 0.9rem",
//           fontSize: "0.9rem",
//         }}
//       />
//       {error ? (
//         <div style={{ color: "#D64545", fontSize: 11.5, marginTop: 4 }}>
//           {t(error)}
//         </div>
//       ) : (
//         helpText && (
//           <Form.Text style={{ color: C.taupe, fontSize: 11.5 }}>
//             {t(helpText)}
//           </Form.Text>
//         )
//       )}
//     </Form.Group>
//   );
// }

// function FieldSelect({
//   label,
//   value,
//   onChange,
//   options,
//   required = false,
//   select,
// }) {
//   const { t } = useTranslation();
//   return (
//     <Form.Group className="mb-3">
//       <Form.Label
//         style={{
//           fontSize: 12,
//           fontWeight: 700,
//           color: C.maroon,
//           textTransform: "uppercase",
//           letterSpacing: "0.04em",
//         }}
//       >
//         {t(label)} {required && <span style={{ color: C.gold }}>*</span>}
//       </Form.Label>
//       <Form.Select
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         style={{
//           background: C.cream,
//           border: `1px solid ${C.border}`,
//           borderRadius: 10,
//           padding: "0.6rem 0.9rem",
//           fontSize: "0.9rem",
//         }}
//       >
//         <option value="">{t(select)}</option>
//         {options.map((o) => (
//           <option key={o.value} value={o.value}>
//             {t(o.label)}
//           </option>
//         ))}
//       </Form.Select>
//     </Form.Group>
//   );
// }

// function PrimaryBtn({
//   children,
//   onClick,
//   disabled = false,
//   fullWidth = false,
//   variant = "primary",
// }) {
//   const styles = {
//     primary: { background: C.maroon, borderColor: C.maroon, color: "#fff" },
//     gold: { background: C.gold, borderColor: C.gold, color: "#fff" },
//     outline: {
//       background: "transparent",
//       border: `2px solid ${C.maroon}`,
//       color: C.maroon,
//     },
//   }[variant];
//   return (
//     <button
//       onClick={onClick}
//       disabled={disabled}
//       className={`btn ${fullWidth ? "w-100" : ""}`}
//       style={{
//         ...styles,
//         fontWeight: 600,
//         borderRadius: 12,
//         padding: "0.6rem 1.3rem",
//         opacity: disabled ? 0.4 : 1,
//         cursor: disabled ? "not-allowed" : "pointer",
//       }}
//     >
//       {children}
//     </button>
//   );
// }

// const STEP_META = [
//   { label: "TXT.DETS.LO", icon: "👤" },
//   { label: "HOM.VAS.DET.UPL", icon: "🏢" },
//   { label: "HOM.VAS.DET.SCN", icon: "🔍" },
//   { label: "USR.HOM.HD.PAY", icon: "💳" },
//   { label: "USR.BD.HMTAB.TBL.CLM.RP", icon: "📊" },
// ];

// // function StepBar({ current }) {
// //   const { t } = useTranslation();
// //   return (
// //     <div className="mx-auto mb-4" style={{ maxWidth: 640 }}>
// //       {/* row 1 — numbered circles + connecting line */}
// //       <div className="d-flex align-items-center">
// //         {STEP_META.map((s, i) => {
// //           const n = i + 1;
// //           const done = n < current;
// //           const active = n === current;
// //           return (
// //             <div
// //               key={s.label}
// //               className="d-flex align-items-center"
// //               style={{ flex: i === STEP_META.length - 1 ? "0 0 auto" : 1 }}
// //             >
// //               <div
// //                 className="d-flex flex-column align-items-center"
// //                 style={{ minWidth: 32 }}
// //               >
// //                 <div
// //                   className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
// //                   style={{
// //                     width: 26,
// //                     height: 26,
// //                     fontSize: 12,
// //                     background: done || active ? C.gold : "#E4E4E4",
// //                     color: done || active ? "#fff" : "#9a9a9a",
// //                   }}
// //                 >
// //                   {done ? "✓" : n}
// //                 </div>
// //                 <span
// //                   className="small mt-1 text-nowrap"
// //                   style={{
// //                     fontSize: 11,
// //                     color: active ? C.maroon : C.taupe,
// //                     fontWeight: active ? 700 : 400,
// //                   }}
// //                 >
// //                   {t(s.label)}
// //                 </span>
// //               </div>
// //               {i !== STEP_META.length - 1 && (
// //                 <div
// //                   className="flex-grow-1"
// //                   style={{
// //                     height: 2,
// //                     background: n < current ? C.gold : "#E4E4E4",
// //                     marginTop: -18,
// //                   }}
// //                 />
// //               )}
// //             </div>
// //           );
// //         })}
// //       </div>

// //       {/* row 2 — icon blocks, active step highlighted */}
// //       <div
// //         className="d-flex mt-2"
// //         style={{ borderRadius: 8, overflow: "hidden" }}
// //       >
// //         {STEP_META.map((s, i) => {
// //           const n = i + 1;
// //           const active = n === current;
// //           return (
// //             <div
// //               key={s.label}
// //               className="flex-fill d-flex flex-column align-items-center justify-content-center py-2"
// //               style={{
// //                 background: active ? C.gold : "#EFEFEF",
// //                 color: active ? "#fff" : "#8a8a8a",
// //                 fontSize: 18,
// //               }}
// //             >
// //               <span>{s.icon}</span>
// //               <span style={{ fontSize: 10, fontWeight: active ? 700 : 400 }}>
// //                 {t(s.label)}
// //               </span>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // }

// function StepBar({ current }) {
//   const { t } = useTranslation();

//   const currentStep = STEP_META[current - 1];

//   return (
//     <div
//       className="mx-auto mb-4"
//       style={{
//         width: "100%",
//         maxWidth: 640,
//       }}
//     >
//       {/* ================= DESKTOP ================= */}
//       <div className="stepbar-desktop">
//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-start",
//             width: "100%",
//           }}
//         >
//           {STEP_META.map((s, i) => {
//             const n = i + 1;
//             const done = n < current;
//             const active = n === current;

//             return (
//               <div
//                 key={s.label}
//                 style={{
//                   flex: 1,
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 {/* Step */}
//                 <div
//                   style={{
//                     width: 34,
//                     flexShrink: 0,
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 30,
//                       height: 30,
//                       borderRadius: "50%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 12,
//                       fontWeight: 700,
//                       background:
//                         done || active ? C.gold : "#E5E5E5",
//                       color:
//                         done || active ? "#fff" : "#999",
//                     }}
//                   >
//                     {done ? "✓" : n}
//                   </div>

//                   <span
//                     style={{
//                       marginTop: 6,
//                       fontSize: 10,
//                       textAlign: "center",
//                       whiteSpace: "nowrap",
//                       color: active ? C.maroon : C.taupe,
//                       fontWeight: active ? 700 : 400,
//                     }}
//                   >
//                     {t(s.label)}
//                   </span>
//                 </div>

//                 {/* Connecting line */}
//                 {i < STEP_META.length - 1 && (
//                   <div
//                     style={{
//                       flex: 1,
//                       height: 2,
//                       marginTop: -20,
//                       background:
//                         n < current
//                           ? C.gold
//                           : "#E5E5E5",
//                     }}
//                   />
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* ================= MOBILE ================= */}
//       <div className="stepbar-mobile">
//         <div
//           style={{
//             background: C.creamCard,
//             border: `1px solid ${C.border}`,
//             borderRadius: 14,
//             padding: "12px 14px",
//             textAlign: "center",
//           }}
//         >
//           {/* Step count */}
//           <div
//             style={{
//               fontSize: 10,
//               fontWeight: 700,
//               color: C.taupe,
//               letterSpacing: "0.08em",
//               textTransform: "uppercase",
//               marginBottom: 8,
//             }}
//           >
//             Step {current} of {STEP_META.length}
//           </div>

//           {/* Icon */}
//           <div
//             style={{
//               width: 42,
//               height: 42,
//               margin: "0 auto 7px",
//               borderRadius: "50%",
//               background: C.gold,
//               color: "#fff",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 20,
//             }}
//           >
//             {currentStep.icon}
//           </div>

//           {/* Current step name */}
//           <div
//             style={{
//               fontSize: 13,
//               fontWeight: 700,
//               color: C.maroon,
//             }}
//           >
//             {t(currentStep.label)}
//           </div>

//           {/* Progress */}
//           <div
//             style={{
//               display: "flex",
//               gap: 5,
//               marginTop: 10,
//               justifyContent: "center",
//             }}
//           >
//             {STEP_META.map((_, i) => (
//               <div
//                 key={i}
//                 style={{
//                   width: i + 1 === current ? 22 : 6,
//                   height: 5,
//                   borderRadius: 10,
//                   background:
//                     i + 1 <= current
//                       ? C.gold
//                       : "#E5E5E5",
//                   transition: "all 0.2s ease",
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Responsive CSS */}
//       <style>
//         {`
//     .stepbar-mobile {
//       display: none;
//     }

//     .stepbar-desktop {
//       display: block;
//     }

//     @media (max-width: 576px) {
//       .stepbar-desktop {
//         display: none;
//       }

//       .stepbar-mobile {
//         display: block;
//       }
//     }
//   `}
//       </style>
//     </div>
//   );
// }

// /* ===================== SCREEN — Know My Lagna =========================== */
// function StepLagna({ onBack, onDone }) {
//   const { t } = useTranslation();
//   const token = window.sessionStorage.getItem("token");
//   const [name, setName] = useState("");
//   const [dob, setDob] = useState("");
//   const [tob, setTob] = useState("");
//   const [pob, setPob] = useState("");
//   const [calculating, setCalculating] = useState(false);
//   const [result, setResult] = useState("");

//   const [searchLocation, setSearchLocation] = useState("");
//   const [options, setOptions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);

//   // const calculate = () => {
//   //   setCalculating(true);
//   //   setTimeout(() => {
//   //     setResult(LAGNAS[Math.floor(Math.random() * LAGNAS.length)]);
//   //     setCalculating(false);
//   //   }, 2000);
//   // };

//   useEffect(() => {
//     const fetchSuggestions = async () => {
//       if (!searchLocation || !token) return;
//       try {
//         // const response = await vasthuUrl.get("/api/vasthu/searchLocation", {
//         //   headers: { Authorization: `Bearer ${token}` },
//         //   params: { keyword: searchLocation, lang: "en" },
//         // });
//         const response = await axios.get(
//           "https://vasthuparam.com/vasthuServices/api/vasthu/searchLocation",
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             params: { keyword: searchLocation, lang: "en" },
//           },
//         );
//         setOptions(response.data);
//         setShowSuggestions(true);
//       } catch (error) {
//         console.error("API Error:", error);
//       }
//     };
//     const delayDebounce = setTimeout(fetchSuggestions, 300);
//     return () => clearTimeout(delayDebounce);
//   }, [searchLocation]);


//   const handleSelectSuggestion = (place) => {
//     setSearchLocation(place);
//     setPob(place);
//     setShowSuggestions(false);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!pob || !dob || !name || !tob) {
//       setMessageType("error");
//       alert("All fields are required.");
//       return;
//     }

//     const payload = {
//       userName: name,
//       userBirthstate: pob,
//       birthDate: dob,
//       birthTime: tob,
//       lang: "en",
//     };

//     try {
//       // const res = await vasthuUrl.post("/api/astro/generate", payload, {
//       //   headers: { Authorization: `Bearer ${token}` },
//       // });
//       const res = await axios.post(
//         "https://vasthuparam.com/vasthuServices/api/astro/generate",
//         payload,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       setResult(res?.data?.lagna);
//     } catch (err) {
//       console.error("Error fetching Panchangam data", err);
//     }
//   };

//   return (
//     <div className="mx-auto px-3 py-4" style={{ maxWidth: 520 }}>
//       <button
//         onClick={onBack}
//         className="btn btn-link text-decoration-none small mb-3 px-0"
//         style={{ color: C.taupe }}
//       >
//         ← Back
//       </button>
//       <VastuCard>
//         <div className="text-center mb-4">
//           <div className="fs-2 mb-2">🔭</div>
//           <GoldHeading sub="Enter your birth details to calculate your Lagna (Ascendant)">
//             {t("HOM.VAS.IMG.DET.KML")}
//           </GoldHeading>
//         </div>

//         {!result ? (
//           <div>
//             <FieldInput
//               label="Full Name"
//               value={name}
//               onChange={setName}
//               placeholder="e.g. Ramesh Kumar"
//               required
//             />
//             <FieldInput
//               label="Date of Birth"
//               value={dob}
//               onChange={setDob}
//               type="date"
//               required
//             />
//             <FieldInput
//               label="Time of Birth"
//               value={tob}
//               onChange={setTob}
//               type="time"
//               required
//             />

//             <Form.Group className="mb-3 position-relative">
//               <Form.Label
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 700,
//                   color: C.maroon,
//                   textTransform: "uppercase",
//                   letterSpacing: "0.04em",
//                 }}
//               >
//                 Place of Birth <span style={{ color: C.gold }}>*</span>
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 value={searchLocation}
//                 placeholder={"e.g. Chennai, Tamil Nadu"}
//                 autoComplete="off"
//                 onChange={(e) => setSearchLocation(e.target.value)}
//                 style={{
//                   background: C.cream,
//                   border: `1px solid ${C.border}`,
//                   borderRadius: 10,
//                   padding: "0.6rem 0.9rem",
//                   fontSize: "0.9rem",
//                 }}
//               />
//               {searchLocation && (
//                 <span
//                   onClick={() => {
//                     setSearchLocation("");
//                     setPob("");
//                   }}
//                   style={{
//                     position: "absolute",
//                     right: 10,
//                     top: "68%",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer",
//                     fontSize: "1.2rem",
//                     color: "#aaa",
//                   }}
//                 >
//                   &times;
//                 </span>
//               )}

//               {showSuggestions && options.length > 0 && (
//                 <ul
//                   style={{
//                     listStyleType: "none",
//                     padding: 0,
//                     marginTop: 4,
//                     border: `1px solid ${C.border}`,
//                     maxHeight: 150,
//                     overflowY: "auto",
//                     position: "absolute",
//                     width: "100%",
//                     backgroundColor: "#fff",
//                     zIndex: 999,
//                     borderRadius: 8,
//                   }}
//                 >
//                   {options.map((place, index) => (
//                     <li
//                       key={index}
//                       onClick={() => handleSelectSuggestion(place)}
//                       style={{
//                         padding: 8,
//                         cursor: "pointer",
//                         borderBottom: `1px solid ${C.border}`,
//                         fontSize: "0.85rem",
//                       }}
//                     >
//                       {place}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </Form.Group>

//             <PrimaryBtn
//               onClick={handleSubmit}
//               disabled={!name || !dob || !tob || !pob || calculating}
//               fullWidth
//               variant="gold"
//             >
//               {calculating ? (
//                 <span className="d-inline-flex align-items-center gap-2">
//                   <Spin size="small" /> Calculating…
//                 </span>
//               ) : (
//                 "Calculate My Lagna"
//               )}
//             </PrimaryBtn>
//           </div>
//         ) : (
//           <div className="text-center">
//             <div
//               className="rounded-circle mx-auto d-flex align-items-center justify-content-center fs-2 mb-3"
//               style={{
//                 width: 80,
//                 height: 80,
//                 background: "#FFF3DC",
//                 border: `4px solid ${C.gold}`,
//               }}
//             >
//               ♈
//             </div>
//             <p
//               className="text-uppercase small mb-1"
//               style={{ color: C.taupe, letterSpacing: "0.1em", fontSize: 11 }}
//             >
//               Your Lagna is
//             </p>
//             <h3
//               style={{
//                 ...display,
//                 fontWeight: 700,
//                 color: C.maroon,
//                 fontSize: "1.6rem",
//               }}
//               className="mb-3"
//             >
//               {result}
//             </h3>
//             <div
//               className="rounded-3 p-3 small mb-4"
//               style={{
//                 background: C.creamCard,
//                 color: C.taupe,
//                 border: `1px solid ${C.border}`,
//               }}
//             >
//               This Lagna is associated with leadership, vitality, and dynamic
//               energy in your home's Vastu alignment.
//             </div>
//             <PrimaryBtn onClick={() => onDone(result)} fullWidth variant="gold">
//               Use This Lagna →
//             </PrimaryBtn>
//           </div>
//         )}
//       </VastuCard>
//     </div>
//   );
// }

// /* ===================== SCREEN — Owner & Home Details ==================== */
// function StepDetails({ onNext, onLagna, prefillLagna, initialDetails }) {
//   const { t } = useTranslation();
//   const [form, setForm] = useState({
//     ownerName: initialDetails?.ownerName || "",
//     lagna: prefillLagna || initialDetails?.lagna || "",
//     doorWidth: initialDetails?.doorWidth || "",
//     doorPosition: initialDetails?.doorPosition || "",
//     perimeter: initialDetails?.perimeter || "",
//     doorGap: initialDetails?.doorGap || "",
//     southLevel: initialDetails?.southLevel || "",
//     northLevel: initialDetails?.northLevel || "",
//     southWestLevel: initialDetails?.southWestLevel || "",
//     northEastLevel: initialDetails?.northEastLevel || "",
//     building_front_width: initialDetails?.hFacingWidth || "",
//     westLevel: initialDetails?.westLevel || "",
//     eastLevel: initialDetails?.eastLevel || "",
//   });
//   const [errors, setErrors] = useState({});

//   function validateHFacingWidth(value) {
//     if (!value) return "";
//     if (!POSITIVE_NUMBER_REGEX.test(value)) return "Numbers only";
//     const num = parseFloat(value);
//     if (num <= 0) return "Value must be greater than 0";
//     if (num > 120) return "Maximum allowed is 120 ft";
//     return "";
//   }

//   const setValidated = (key, validatorFn) => (v) => {
//     const errMsg = validatorFn(v);
//     setErrors((e) => ({ ...e, [key]: errMsg }));

//     if (
//       (validatorFn === validatePositiveNumber ||
//         validatorFn === validateHFacingWidth) &&
//       v &&
//       !POSITIVE_NUMBER_REGEX.test(v)
//     ) {
//       return;
//     }
//     if (validatorFn === validateName && v && !NAME_REGEX.test(v)) {
//       return;
//     }
//     setForm((f) => ({ ...f, [key]: v }));
//   };
//   const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

//   const setPaired = (key, pairKey) => (v) => {
//     setForm((f) => ({
//       ...f,
//       [key]: v,
//       [pairKey]: v === "low" ? "high" : v === "high" ? "low" : f[pairKey],
//     }));
//   };

//   const valid =
//     form.ownerName &&
//     !errors.ownerName &&
//     form.lagna &&
//     form.doorWidth &&
//     parseFloat(form.doorWidth) > 0 &&
//     !errors.doorWidth &&
//     form.doorPosition &&
//     form.perimeter &&
//     parseFloat(form.perimeter) > 0 &&
//     !errors.perimeter &&
//     form.hFacingWidth &&
//     parseFloat(form.hFacingWidth) > 0 &&
//     parseFloat(form.hFacingWidth) <= 120 &&
//     !errors.hFacingWidth &&
//     form.doorGap &&
//     parseFloat(form.doorGap) > 0 &&
//     !errors.doorGap &&
//     form.southLevel &&
//     form.northLevel &&
//     form.southWestLevel &&
//     form.northEastLevel &&
//     form.westLevel &&
//     form.eastLevel;

//   return (
//     <div className="mx-auto px-3 py-4" style={{ maxWidth: 560 }}>
//       <StepBar current={1} />
//       <VastuCard>
//         <GoldHeading sub="Please provide your home details for accurate Vastu analysis">
//           Owner &amp; Home Details
//         </GoldHeading>

//         <FieldInput
//           label="USR.VSH.HFTAB.LBL.HO"
//           value={form.ownerName}
//           onChange={setValidated("ownerName", validateName)}
//           placeholder="USR.VSH.HFTAB.HO.PH"
//           required
//           error={errors.ownerName}
//         />

//         <Form.Group className="mb-3">
//           <Form.Label
//             style={{
//               fontSize: 12,
//               fontWeight: 700,
//               color: C.maroon,
//               textTransform: "uppercase",
//               letterSpacing: "0.04em",
//             }}
//           >
//             {t("USR.VSH.HFTAB.LG.PH")} <span style={{ color: C.gold }}>*</span>
//           </Form.Label>
//           <div className="d-flex gap-2">
//             <Form.Select
//               className="flex-grow-1"
//               value={form.lagna}
//               onChange={(e) => set("lagna")(e.target.value)}
//               style={{
//                 background: C.cream,
//                 border: `1px solid ${C.border}`,
//                 borderRadius: 10,
//               }}
//             >
//               <option value=""> {t("USR.VSH.HFTAB.LG.PH")}…</option>
//               {LAGNA_OPTIONS.map((o) => (
//                 <option key={o.value} value={o.value}>
//                   {o.label}
//                 </option>
//               ))}
//             </Form.Select>
//             <button
//               // onClick={onLagna}
//               onClick={() => onLagna(form)}
//               className="btn small text-nowrap fw-semibold px-3"
//               style={{
//                 background: "#FFF3DC",
//                 color: C.gold,
//                 border: `1px solid ${C.gold}`,
//                 fontSize: 12,
//               }}
//             >
//               {t("HOM.VAS.IMG.DET.KML")}
//             </button>
//           </div>
//         </Form.Group>

//         {/* <FieldSelect
//           label="South vs North"
//           value={form.southNorth}
//           onChange={set("southNorth")}
//           required
//           options={[
//             { value: "south", label: "Slope towards South" },
//             { value: "north", label: "Slope towards North" },
//           ]}
//         />

//         <FieldSelect
//           label="South West vs North East"
//           value={form.southwestNortheast}
//           onChange={set("southwestNortheast")}
//           required
//           options={[
//             { value: "southwest", label: "Slope towards South West" },
//             { value: "northeast", label: "Slope towards North East" },
//           ]}
//         />

//         <FieldSelect
//           label="West vs East"
//           value={form.westEast}
//           onChange={set("westEast")}
//           required
//           options={[
//             { value: "west", label: "Slope towards West" },
//             { value: "east", label: "Slope towards East" },
//           ]}
//         /> */}

//         <div className="d-flex gap-2">
//           <div className="flex-grow-1">
//             <FieldSelect
//               label="USR.VSH.LVLTAB.SXN.LB.ST"
//               value={form.southLevel}
//               onChange={setPaired("southLevel", "northLevel")}
//               required
//               options={LEVEL_OPTIONS}
//               select="USR.VSH.LVLTAB.SXN.ST.DD.PH"
//             />
//           </div>
//           <div className="flex-grow-1">
//             <FieldSelect
//               label="USR.VSH.LVLTAB.SXN.LB.NR"
//               value={form.northLevel}
//               onChange={setPaired("northLevel", "southLevel")}
//               required
//               options={LEVEL_OPTIONS}
//               select="USR.VSH.LVLTAB.SXN.NR.DD.PH"
//             />
//           </div>
//         </div>

//         <div className="d-flex gap-2">
//           <div className="flex-grow-1">
//             <FieldSelect
//               label="USR.VSH.LVLTAB.SWXNE.LB.ST"
//               value={form.southWestLevel}
//               onChange={setPaired("southWestLevel", "northEastLevel")}
//               required
//               options={LEVEL_OPTIONS}
//               select="USR.VSH.LVLTAB.SWXNE.ST.DD.PH"
//             />
//           </div>
//           <div className="flex-grow-1">
//             <FieldSelect
//               label="USR.VSH.LVLTAB.SWXNE.LB.NR"
//               value={form.northEastLevel}
//               onChange={setPaired("northEastLevel", "southWestLevel")}
//               required
//               options={LEVEL_OPTIONS}
//               select="USR.VSH.LVLTAB.SWXNE.NR.DD.PH"
//             />
//           </div>
//         </div>

//         <div className="d-flex gap-2">
//           <div className="flex-grow-1">
//             <FieldSelect
//               label="USR.VSH.LVLTAB.WXE.LB.ST"
//               value={form.westLevel}
//               onChange={setPaired("westLevel", "eastLevel")}
//               required
//               options={LEVEL_OPTIONS}
//               select="USR.VSH.LVLTAB.WXE.ST.DD.PH"
//             />
//           </div>
//           <div className="flex-grow-1">
//             <FieldSelect
//               label="USR.VSH.LVLTAB.WXE.LB.NR"
//               value={form.eastLevel}
//               onChange={setPaired("eastLevel", "westLevel")}
//               required
//               options={LEVEL_OPTIONS}
//               select="USR.VSH.LVLTAB.WXE.NR.DD.PH"
//             />
//           </div>
//         </div>

//         <FieldInput
//           label="USR.VSH.HFTAB.LBL.MDW"
//           value={form.doorWidth}
//           onChange={setValidated("doorWidth", validatePositiveNumber)}
//           placeholder="e.g. 3.5"
//           required
//           error={errors.doorWidth}
//         />

//         <FieldInput
//           label="USR.VSH.HFTAB.LBL.MDD"
//           value={form.doorGap}
//           onChange={setValidated("doorGap", validatePositiveNumber)}
//           placeholder="e.g. 11"
//           required
//           helpText="USR.VSH.HFTAB.MDD.HTXT"
//           error={errors.doorGap}
//         />

//         <FieldSelect
//           label="USR.VSH.HFTAB.LBL.HF"
//           value={form.doorPosition}
//           onChange={set("doorPosition")}
//           required
//           options={DIRECTION_OPTIONS}
//           select="USR.VSH.HFTAB.HF.PH"
//           helpText="USR.VSH.HFTAB.HF.HTXT"
//         />

//         <FieldInput
//           label="USR.VFPR.TBL.CLMN.PR"
//           value={form.perimeter}
//           onChange={setValidated("perimeter", validatePositiveNumber)}
//           placeholder="e.g. 120"
//           required
//           error={errors.perimeter}
//         />

//         <FieldInput
//           label="USR.VSH.HFTAB.LBL.FFW"
//           value={form.hFacingWidth}
//           onChange={setValidated("hFacingWidth", validateHFacingWidth)}
//           placeholder="e.g. 40"
//           required
//           error={errors.hFacingWidth}
//         />

//         <div className="mt-3">
//           <PrimaryBtn
//             onClick={() => onNext(form)}
//             disabled={!valid}
//             fullWidth
//             variant="gold"
//           >
//             Proceed to Upload →
//           </PrimaryBtn>
//         </div>
//       </VastuCard>
//     </div>
//   );
// }

// /* ====================  SCREEN — Upload House Plan ========================= */
// function StepUpload({ onNext, onBack, pricing, details }) {
//   const { options } = pricing;
//   const token = window.sessionStorage.getItem("token");
//   const userId = window.sessionStorage.getItem("userId");
//   const [houseType, setHouseType] = useState(null);
//   const [files, setFiles] = useState([]);
//   const [previews, setPreviews] = useState([]);
//   const [agreed, setAgreed] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState("");
//   const [detectedCount, setDetectedCount] = useState(null);

//   const selectedOption = options.find((o) => o.key === houseType);
//   const expectedCount = selectedOption
//     ? getFloorCountFromLabel(selectedOption.label)
//     : 0;

//   // Was hardcoded to exactly 2 refs (`[useRef(null), useRef(null)]`). For a
//   // G+3+ house type (expectedCount up to 5), clicking drop zone 3/4/5 hit an
//   // undefined ref and silently did nothing — those floor plans could never
//   // be selected. Map-backed refs support any number of slots.
//   const inputRefsMap = useRef({});
//   const getInputRef = (index) => {
//     if (!inputRefsMap.current[index]) {
//       inputRefsMap.current[index] = { current: null };
//     }
//     return inputRefsMap.current[index];
//   };

//   const detectedOption = options.find(
//     (o) => getFloorCountFromLabel(o.label) === detectedCount,
//   );

//   const handleFile = (f, index) => {
//     const allowed = [
//       "image/png",
//       "image/jpeg",
//       "application/pdf",
//     ];

//     if (!allowed.includes(f.type)) {
//       setError("Please upload PNG, JPG or PDF only.");
//       return;
//     }

//     setError("");

//     setFiles((prev) => {
//       const next = [...prev];
//       next[index] = f;
//       return next;
//     });

//     setPreviews((prev) => {
//       const next = [...prev];

//       next[index] = f.type.startsWith("image/")
//         ? URL.createObjectURL(f)
//         : null;

//       return next;
//     });
//   };

//   const handleDrop = (e, index) => {
//     e.preventDefault();
//     const f = e.dataTransfer.files[0];
//     if (f) handleFile(f, index);   // was: images only, which blocked PDFs
//   };

//   // const handleFile = (f, index) => {
//   //   setFiles((prev) => {
//   //     const next = [...prev];
//   //     next[index] = f;
//   //     return next;
//   //   });
//   //   setPreviews((prev) => {
//   //     const next = [...prev];
//   //     next[index] = URL.createObjectURL(f);
//   //     return next;
//   //   });
//   // };

//   // const handleDrop = (e, index) => {
//   //   e.preventDefault();
//   //   const f = e.dataTransfer.files[0];
//   //   if (f && f.type.startsWith("image/")) handleFile(f, index);
//   // };

//   const allFilesReady = Boolean(files[0]); // file1 mandatory, rest optional

//   const handleStartAnalysis = async () => {
//     if (!allFilesReady) return;
//     setUploading(true);
//     setError("");
//     try {
//       const formData = new FormData();

//       // Was hardcoded to only file1/file2, so a G+3+ house (expectedCount
//       // up to 5) silently dropped floor plans 3, 4, and 5 even if the user
//       // had selected them — the backend (file1..file5) never received
//       // them, causing an actual/expected plan-count mismatch.
//       const maxSlots = Math.min(Math.max(expectedCount, 1), 5);
//       for (let i = 0; i < maxSlots; i++) {
//         formData.append(`file${i + 1}`, files[i] || "");
//       }

//       formData.append("expected_plan_count", expectedCount);
//       formData.append("ownerName", details?.ownerName || "");
//       formData.append("lagna", details?.lagna || "");
//       formData.append("roomHeight", details?.roomHeight ?? "");
//       formData.append("doorWidth", details?.doorWidth || "");
//       formData.append("doorPosition", details?.doorPosition || "");
//       formData.append("perimeter", details?.perimeter || "");
//       // formData.append("hFacingWidth", details?.hFacingWidth || "");
//       formData.append("building_front_width", details?.hFacingWidth || "");
//       formData.append("doorGap", details?.doorGap || "");
//       const levels = deriveLevelValues(details);
//       formData.append("southLevel", levels.southLevel);
//       formData.append("northLevel", levels.northLevel);
//       formData.append("southWestLevel", levels.southWestLevel);
//       formData.append("northEastLevel", levels.northEastLevel);
//       formData.append("westLevel", levels.westLevel);
//       formData.append("eastLevel", levels.eastLevel);
//       formData.append("userUUId", userId);

//       const response = await vasthuUrl.post(`/ocr/extract`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       onNext(response.data, houseType);
//     } catch (err) {
//       console.error("OCR Extract Error:", err);
//       const rawMsg =
//         err?.response?.data?.errors?.[0] ||
//         err?.response?.data?.detail ||
//         "Upload failed. Please try again.";

//       const detailMatch = rawMsg.match(/"detail"\s*:\s*"([^"]*(?:\\.[^"]*)*)"/);
//       const cleanMsg = detailMatch ? detailMatch[1] : rawMsg;

//       const countMatch = cleanMsg.match(
//         /(?:detected|extracted)\s+(\d+)\s+plan/i,
//       );
//       const detected = countMatch ? parseInt(countMatch[1], 10) : null;

//       const detectedOpt = detected
//         ? options.find((o) => getFloorCountFromLabel(o.label) === detected)
//         : null;

//       setDetectedCount(detectedOpt ? detected : null);
//       setError(cleanMsg);
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="mx-auto px-3 py-4" style={{ maxWidth: 560 }}>
//       <StepBar current={2} />
//       <button
//         onClick={onBack}
//         className="btn btn-link text-decoration-none small mb-3 px-0"
//         style={{ color: C.taupe }}
//       >
//         ← Back
//       </button>
//       <VastuCard>
//         <GoldHeading sub="Select your house type to view pricing">
//           Upload House Plan
//         </GoldHeading>

//         <Alert
//           style={{
//             background: C.creamCard,
//             border: `1px solid ${C.border}`,
//             color: C.taupe,
//             fontSize: "0.9rem",
//           }}
//         >
//           <span style={{ color: C.gold, fontWeight: 600 }}>ℹ️ Note:</span> The
//           cost depends on the complexity and number of floors in your uploaded
//           plan.
//         </Alert>

//         <div className="mb-3">
//           <p
//             style={{
//               fontSize: 12,
//               fontWeight: 700,
//               color: C.maroon,
//               textTransform: "uppercase",
//               letterSpacing: "0.04em",
//             }}
//             className="mb-2"
//           >
//             Select House Type <span style={{ color: C.gold }}>*</span>
//           </p>
//           <div className="d-flex flex-column gap-2">
//             {options
//               .filter((o) => !o.isCustomQuote)
//               .map((o) => (
//                 <button
//                   key={o.key}
//                   onClick={() => {
//                     setHouseType(o.key);
//                     setAgreed(false);
//                     setFiles([]);
//                     setPreviews([]);
//                     setError("");
//                   }}
//                   className="w-100 d-flex align-items-center justify-content-between px-3 py-2"
//                   style={{
//                     borderRadius: 12,
//                     border: `2px solid ${houseType === o.key ? C.gold : C.border
//                       }`,
//                     background: houseType === o.key ? C.creamCard : "#fff",
//                   }}
//                 >
//                   <span className="fw-medium small" style={{ color: C.ink }}>
//                     {o.label}
//                   </span>
//                   <span className="d-flex align-items-center gap-2">
//                     <span className="fw-bold" style={{ color: C.gold }}>
//                       ₹{o.price.toLocaleString()}
//                     </span>
//                     <span
//                       className="rounded-circle d-inline-flex align-items-center justify-content-center"
//                       style={{
//                         width: 16,
//                         height: 16,
//                         border: `2px solid ${houseType === o.key ? C.gold : C.border
//                           }`,
//                         background:
//                           houseType === o.key ? C.gold : "transparent",
//                       }}
//                     >
//                       {houseType === o.key && (
//                         <span
//                           className="rounded-circle bg-white"
//                           style={{ width: 6, height: 6 }}
//                         />
//                       )}
//                     </span>
//                   </span>
//                 </button>
//               ))}
//           </div>
//         </div>

//         {houseType && !agreed && (
//           <Alert
//             style={{
//               background: "#FFF3DC",
//               border: `1px solid rgba(200,134,10,.35)`,
//               color: C.taupe,
//               fontSize: "0.9rem",
//             }}
//           >
//             Proceeding will charge{" "}
//             <span className="fw-bold" style={{ color: C.gold }}>
//               ₹{selectedOption?.price.toLocaleString()}
//             </span>{" "}
//             for a {selectedOption?.label} Vastu analysis. Do you agree?
//             <button
//               onClick={() => setAgreed(true)}
//               className="btn btn-sm ms-3 rounded-pill"
//               style={{ background: C.gold, color: "#fff", fontSize: 11 }}
//             >
//               Yes, Proceed
//             </button>
//           </Alert>
//         )}

//         {agreed && (
//           <div>
//             <p
//               style={{
//                 fontSize: 12,
//                 fontWeight: 700,
//                 color: C.maroon,
//                 textTransform: "uppercase",
//                 letterSpacing: "0.04em",
//               }}
//               className="mb-2"
//             >
//               Upload {expectedCount > 1 ? "All Floor Plans" : "House Plan"}{" "}
//               <span style={{ color: C.gold }}>*</span>
//             </p>

//             <div className="d-flex flex-column gap-3">
//               {Array.from({ length: expectedCount }).map((_, index) => (
//                 <div key={index}>
//                   {expectedCount > 1 && (
//                     <p
//                       className="small fw-semibold mb-1"
//                       style={{ color: C.maroon }}
//                     >
//                       Floor {index + 1} Plan
//                       {index > 0 && index === expectedCount - 1 && (
//                         <span style={{ color: C.taupe, fontWeight: 400 }}>
//                           {" "}
//                           (Optional — skip if an earlier sheet already covers
//                           it)
//                         </span>
//                       )}
//                     </p>
//                   )}
//                   <div
//                     onDrop={(e) => handleDrop(e, index)}
//                     onDragOver={(e) => e.preventDefault()}
//                     onClick={() => getInputRef(index).current?.click()}
//                     style={{
//                       border: `2px dashed ${C.gold}`,
//                       borderRadius: 16,
//                       padding: "1.25rem",
//                       textAlign: "center",
//                       cursor: "pointer",
//                     }}
//                   >
//                     {/* <input
//                       ref={getInputRef(index)}
//                       type="file"
//                       accept="image/*"
//                       className="d-none"
//                       onChange={(e) => {
//                         if (e.target.files?.[0])
//                           handleFile(e.target.files[0], index);
//                       }}
//                     /> */}
//                     <input
//                       ref={getInputRef(index)}
//                       type="file"
//                       accept="image/png,image/jpeg,application/pdf"
//                       className="d-none"
//                       onChange={(e) => {
//                         if (e.target.files?.[0]) {
//                           handleFile(e.target.files[0], index);
//                         }
//                         e.target.value = "";
//                       }}
//                     />
//                     {previews[index] ? (
//                       // <div>
//                       //   <img
//                       //     src={previews[index]}
//                       //     alt={`House plan ${index + 1} preview`}
//                       //     className="mx-auto rounded-3 mb-2"
//                       //     style={{ maxHeight: 140, objectFit: "contain" }}
//                       //   />
//                       //   <p className="small mb-0" style={{ color: C.taupe }}>
//                       //     {files[index]?.name} · Click to change
//                       //   </p>
//                       // </div>
//                       <div>
//                         <img
//                           src={previews[index]}
//                           alt={`House plan ${index + 1} preview`}
//                           className="mx-auto rounded-3 mb-2"
//                           style={{ maxHeight: 140, objectFit: "contain" }}
//                         />

//                         <p className="small mb-0" style={{ color: C.taupe }}>
//                           {/* {files[index]?.name} · Click to change */}
//                           <div>
//                             {files[index] ? (
//                               files[index].type === "application/pdf" ? (
//                                 <div className="py-2">
//                                   <div className="fs-1 mb-2">📄</div>

//                                   <p
//                                     className="small fw-semibold mb-1"
//                                     style={{ color: C.maroon }}
//                                   >
//                                     PDF uploaded
//                                   </p>

//                                   <p
//                                     className="small mb-0 text-truncate"
//                                     style={{ color: C.taupe }}
//                                   >
//                                     {files[index].name}
//                                   </p>

//                                   <p
//                                     className="small mt-2 mb-0"
//                                     style={{ color: C.gold }}
//                                   >
//                                     Click to change
//                                   </p>
//                                 </div>
//                               ) : (
//                                 <div>
//                                   <img
//                                     src={previews[index]}
//                                     alt={`House plan ${index + 1} preview`}
//                                     className="mx-auto rounded-3 mb-2"
//                                     style={{
//                                       maxHeight: 140,
//                                       maxWidth: "100%",
//                                       objectFit: "contain",
//                                       display: "block",
//                                     }}
//                                   />

//                                   <p
//                                     className="small mb-0 text-truncate"
//                                     style={{ color: C.taupe }}
//                                   >
//                                     {files[index].name}
//                                   </p>

//                                   <p
//                                     className="small mt-1 mb-0"
//                                     style={{ color: C.gold }}
//                                   >
//                                     Click to change
//                                   </p>
//                                 </div>
//                               )
//                             ) : (
//                               <div>
//                                 <div className="fs-1 mb-2">📐</div>

//                                 <p
//                                   className="small fw-semibold mb-1"
//                                   style={{ color: C.maroon }}
//                                 >
//                                   Drop your house plan here
//                                 </p>

//                                 <p
//                                   className="small mb-0"
//                                   style={{ color: C.taupe }}
//                                 >
//                                   or click to browse · PNG, JPG, PDF
//                                 </p>
//                               </div>
//                             )}
//                           </div>
//                         </p>
//                       </div>
//                     ) : (
//                       <div>
//                         <div className="fs-1 mb-2">📐</div>
//                         <p
//                           className="small fw-semibold mb-1"
//                           style={{ color: C.maroon }}
//                         >
//                           Drop your house plan here
//                         </p>
//                         <p className="small mb-0" style={{ color: C.taupe }}>
//                           or click to browse · PNG, JPG, PDF
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {error && (
//               <Alert
//                 className="mt-3 mb-0"
//                 style={{
//                   background: "#FDEDED",
//                   color: "#B23A3A",
//                   fontSize: "0.85rem",
//                 }}
//               >
//                 {error}
//                 {detectedOption && detectedOption.key !== houseType && (
//                   <div className="mt-2">
//                     <button
//                       onClick={() => {
//                         setHouseType(detectedOption.key);
//                         setError("");
//                       }}
//                       className="btn btn-sm rounded-pill"
//                       style={{
//                         background: C.gold,
//                         color: "#fff",
//                         fontSize: 11,
//                       }}
//                     >
//                       Switch to {detectedOption.label} ( ₹
//                       {detectedOption.price?.toLocaleString() || "0"})
//                     </button>
//                   </div>
//                 )}
//               </Alert>
//             )}
//             <div className="mt-3">
//               <PrimaryBtn
//                 onClick={handleStartAnalysis}
//                 disabled={!allFilesReady || uploading}
//                 fullWidth
//                 variant="gold"
//               >
//                 {uploading ? (
//                   <span className="d-inline-flex align-items-center gap-2">
//                     <Spin size="small" /> Analyzing…
//                   </span>
//                 ) : (
//                   "Start Analysis →"
//                 )}
//               </PrimaryBtn>
//             </div>
//           </div>
//         )}
//       </VastuCard>
//     </div>
//   );
// }

// /* ====================  SCREEN — Scanning ============================= */
// function StepScanning({ onDone }) {
//   const [phase, setPhase] = useState(0);
//   const PHASES = [
//     "Detecting floor count…",
//     "Extracting measurements…",
//     "Identifying rooms…",
//     "Analyzing directions…",
//     "Checking Vastu elements…",
//     "Finalizing report data…",
//   ];

//   useEffect(() => {
//     let i = 0;
//     const timer = setInterval(() => {
//       i++;
//       setPhase(i);
//       if (i >= PHASES.length) {
//         clearInterval(timer);
//         setTimeout(onDone, 800);
//       }
//     }, 900);
//     return () => clearInterval(timer);
//   }, []);

//   const progress = Math.round((phase / PHASES.length) * 100);

//   return (
//     <div className="mx-auto px-3 py-5 text-center" style={{ maxWidth: 460 }}>
//       <StepBar current={3} />
//       <div
//         className="mx-auto mb-4 position-relative"
//         style={{ width: 160, height: 160 }}
//       >
//         <Progress
//           type="circle"
//           percent={progress}
//           size={160}
//           strokeColor={{ "0%": C.maroon, "100%": C.gold }}
//           trailColor={C.border}
//           format={() => <span style={{ fontSize: 0 }} />}
//         />
//         <div className="position-absolute top-50 start-50 translate-middle">
//           <OmSymbol size={40} />
//         </div>
//       </div>
//       <h2
//         style={{
//           ...display,
//           fontWeight: 700,
//           color: C.maroon,
//           fontSize: "1.7rem",
//         }}
//         className="mb-2"
//       >
//         Scanning…
//       </h2>
//       <p className="small mb-3" style={{ color: C.taupe, minHeight: 24 }}>
//         {PHASES[Math.min(phase, PHASES.length - 1)]}
//       </p>
//       <p className="small" style={{ color: C.taupe }}>
//         {progress}% complete
//       </p>
//     </div>
//   );
// }

// // /* =================== SCREEN — Payment =================================== */
// // function StepPayment({ houseType, ownerName, onPay, pricing }) {
// //   const { options } = pricing;
// //   const selectedOption = options.find((o) => o.key === houseType);
// //   const [paying, setPaying] = useState(false);
// //   const token = window.sessionStorage.getItem("token");
// //   const userId = window.sessionStorage.getItem("userId");

// //   const handlePay = async () => {
// //     if (paying || !selectedOption) return;
// //     setPaying(true);

// //     try {
// //       const res = await vasthuUrl.post(
// //         "/openapi/createhomevasthuorderapi",
// //         {
// //           userUuid: userId,
// //           pricingId: Number(selectedOption.id),
// //           price: Number(selectedOption.price),
// //           currency: "356",
// //         },
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //             "Content-Type": "application/json",
// //           },
// //         },
// //       );

// //       if (!res.data) {
// //         throw new Error("Empty response from Vasthu payment API");
// //       }

// //       if (res.data.status !== 200) {
// //         throw new Error(
// //           `BillDesk order creation failed. Status: ${res.data.status}`,
// //         );
// //       }

// //       if (!res.data.bdOrderId) {
// //         throw new Error("BillDesk order ID is missing");
// //       }

// //       if (!res.data.authToken) {
// //         throw new Error("BillDesk auth token is missing");
// //       }

// //       BillDeskPay(res.data, BillDeskPayHandler)
// //         .then((config) => {
// //           if (!window.loadBillDeskSdk) {
// //             throw new Error("BillDesk SDK is not loaded");
// //           }
// //           window.loadBillDeskSdk(config);
// //         })
// //         .catch((err) => {
// //           console.error("Payment initialization failed:", err);
// //           setPaying(false);
// //         });
// //     } catch (err) {
// //       console.error(
// //         "Vasthu payment error:",
// //         err?.response?.data || err?.message,
// //       );
// //       setPaying(false);
// //     }
// //   };

// //   const BillDeskPayHandler = (txn) => {
// //     if (!txn?.txnResponse?.transaction_response) {
// //       console.error("Invalid BillDesk transaction response:", txn);
// //       setPaying(false);
// //       return;
// //     }

// //     vasthuUrl
// //       .post(
// //         "/user/bdpaymentresponseuihomevasthu",
// //         {
// //           txn: txn.txnResponse.transaction_response,
// //         },
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //         },
// //       )
// //       .then((res) => {
// //         if (res.data?.transaction_error_type === "success") {
// //           return vasthuUrl.post(
// //             "/user/bdpaymentresponsehandlerhomevasthu",
// //             txn,
// //             {
// //               headers: {
// //                 Authorization: `Bearer ${token}`,
// //               },
// //             },
// //           );
// //         }

// //         throw new Error(
// //           res.data?.transaction_error_desc || "BillDesk payment failed",
// //         );
// //       })
// //       .then(() => {
// //         setPaying(false);
// //         onPay();
// //       })
// //       .catch((err) => {
// //         console.error("BillDesk payment response error:", err);
// //         setPaying(false);
// //       });
// //   };

// //   const houseOption = options.find((o) => o.key === houseType);
// //   const total = houseOption?.price || 0;

// //   return (
// //     <div className="mx-auto px-3 py-4" style={{ maxWidth: 480 }}>
// //       <StepBar current={4} />
// //       <VastuCard>
// //         <GoldHeading sub="Secure payment powered by Razorpay">
// //           Payment Summary
// //         </GoldHeading>
// //         <div
// //           className="rounded-3 p-3 mb-4 small"
// //           style={{ background: C.sand, border: `1px solid ${C.border}` }}
// //         >
// //           <div className="d-flex justify-content-between mb-2">
// //             <span style={{ color: C.taupe }}>Owner</span>
// //             <span className="fw-medium">{ownerName || "User"}</span>
// //           </div>
// //           <div className="d-flex justify-content-between mb-2">
// //             <span style={{ color: C.taupe }}>Plan Type</span>
// //             <span className="fw-medium">{houseOption?.label || houseType}</span>
// //           </div>
// //           <div className="d-flex justify-content-between mb-2">
// //             <span style={{ color: C.taupe }}>Analysis Fee</span>
// //             <span className="fw-medium">₹{total.toLocaleString()}</span>
// //           </div>
// //         </div>
// //         <PrimaryBtn
// //           onClick={handlePay}
// //           disabled={paying}
// //           fullWidth
// //           variant="gold"
// //         >
// //           {paying ? (
// //             <span className="d-inline-flex align-items-center gap-2">
// //               <Spin size="small" /> Processing Payment…
// //             </span>
// //           ) : (
// //             `Pay ₹${total.toLocaleString()} →`
// //           )}
// //         </PrimaryBtn>
// //         <p className="small text-center mt-3 mb-0" style={{ color: C.taupe }}>
// //           🔒 Secured with 256-bit SSL encryption
// //         </p>
// //       </VastuCard>
// //     </div>
// //   );
// // }

// /* =================== SCREEN — Payment ==================================
//    https  → real BillDesk payment
//    http   → simulated payment (test build)
// ======================================================================== */
// function StepPayment({ houseType, ownerName, onPay, pricing }) {
//   const { options } = pricing;
//   const selectedOption = options.find((o) => o.key === houseType);
//   const [paying, setPaying] = useState(false);
//   const token = window.sessionStorage.getItem("token");
//   const userId = window.sessionStorage.getItem("userId");

//   const isHttps = window.location.protocol === "https:";
//   // const isHttps = window.location.protocol;

//   // console.log("isHttps", isHttps)

//   /* ---------- http: fake payment ---------- */
//   const handleFakePay = () => {
//     console.warn(
//       "[TEST BUILD] Skipping real BillDesk payment — simulating success.",
//     );
//     setTimeout(() => {
//       setPaying(false);
//       onPay();
//     }, 1200);
//   };

//   /* ---------- https: real BillDesk ---------- */
//   const BillDeskPayHandler = (txn) => {
//     if (!txn?.txnResponse?.transaction_response) {
//       console.error("Invalid BillDesk transaction response:", txn);
//       setPaying(false);
//       return;
//     }

//     vasthuUrl
//       .post(
//         "/user/bdpaymentresponseuihomevasthu",
//         { txn: txn.txnResponse.transaction_response },
//         { headers: { Authorization: `Bearer ${token}` } },
//       )
//       .then((res) => {
//         if (res.data?.transaction_error_type === "success") {
//           return vasthuUrl.post(
//             "/user/bdpaymentresponsehandlerhomevasthu",
//             txn,
//             { headers: { Authorization: `Bearer ${token}` } },
//           );
//         }
//         throw new Error(
//           res.data?.transaction_error_desc || "BillDesk payment failed",
//         );
//       })
//       .then(() => {
//         setPaying(false);
//         onPay();
//       })
//       .catch((err) => {
//         console.error("BillDesk payment response error:", err);
//         setPaying(false);
//       });
//   };

//   const handleRealPay = async () => {
//     try {
//       const res = await vasthuUrl.post(
//         "/openapi/createhomevasthuorderapi",
//         {
//           userUuid: userId,
//           pricingId: Number(selectedOption.id),
//           price: Number(selectedOption.price),
//           currency: "356",
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       if (!res.data) throw new Error("Empty response from Vasthu payment API");
//       if (res.data.status !== 200)
//         throw new Error(
//           `BillDesk order creation failed. Status: ${res.data.status}`,
//         );
//       if (!res.data.bdOrderId) throw new Error("BillDesk order ID is missing");
//       if (!res.data.authToken)
//         throw new Error("BillDesk auth token is missing");

//       BillDeskPay(res.data, BillDeskPayHandler)
//         .then((config) => {
//           if (!window.loadBillDeskSdk) {
//             throw new Error("BillDesk SDK is not loaded");
//           }
//           window.loadBillDeskSdk(config);
//         })
//         .catch((err) => {
//           console.error("Payment initialization failed:", err);
//           setPaying(false);
//         });
//     } catch (err) {
//       console.error(
//         "Vasthu payment error:",
//         err?.response?.data || err?.message,
//       );
//       setPaying(false);
//     }
//   };

//   const handlePay = () => {
//     if (paying || !selectedOption) return;
//     setPaying(true);
//     if (isHttps) handleRealPay();
//     else handleFakePay();
//   };

//   const houseOption = options.find((o) => o.key === houseType);
//   const total = houseOption?.price || 0;

//   return (
//     <div className="mx-auto px-3 py-4" style={{ maxWidth: 480 }}>
//       <StepBar current={4} />
//       <VastuCard>
//         <GoldHeading sub="Secure payment powered by Razorpay">
//           Payment Summary
//         </GoldHeading>

//         {!isHttps && (
//           <div
//             className="rounded-3 p-2 mb-3 small text-center fw-semibold"
//             style={{
//               background: "#FFF3DC",
//               color: "#7B1E1E",
//               border: "1px dashed #C8860A",
//             }}
//           >
//             ⚠️ TEST BUILD — payment is simulated, no real BillDesk call
//           </div>
//         )}

//         <div
//           className="rounded-3 p-3 mb-4 small"
//           style={{ background: C.sand, border: `1px solid ${C.border}` }}
//         >
//           <div className="d-flex justify-content-between mb-2">
//             <span style={{ color: C.taupe }}>Owner</span>
//             <span className="fw-medium">{ownerName || "User"}</span>
//           </div>
//           <div className="d-flex justify-content-between mb-2">
//             <span style={{ color: C.taupe }}>Plan Type</span>
//             <span className="fw-medium">{houseOption?.label || houseType}</span>
//           </div>
//           <div className="d-flex justify-content-between mb-2">
//             <span style={{ color: C.taupe }}>Analysis Fee</span>
//             <span className="fw-medium">₹{total.toLocaleString()}</span>
//           </div>
//         </div>

//         <PrimaryBtn
//           onClick={handlePay}
//           disabled={paying}
//           fullWidth
//           variant="gold"
//         >
//           {paying ? (
//             <span className="d-inline-flex align-items-center gap-2">
//               <Spin size="small" /> Processing Payment…
//             </span>
//           ) : (
//             `Pay ₹${total.toLocaleString()} →`
//           )}
//         </PrimaryBtn>
//         <p className="small text-center mt-3 mb-0" style={{ color: C.taupe }}>
//           🔒 Secured with 256-bit SSL encryption
//         </p>
//       </VastuCard>
//     </div>
//   );
// }

// /* =================== SCREEN — Post Payment choice ======================== */
// function StepPostPayment({ onContinue, onValidate, generating, error }) {
//   return (
//     <div className="mx-auto px-3 py-4 text-center" style={{ maxWidth: 480 }}>
//       <div
//         className="rounded-circle mx-auto d-flex align-items-center justify-content-center fs-1 mb-3"
//         style={{ width: 80, height: 80, background: "#dcf5e6" }}
//       >
//         ✅
//       </div>
//       <h2
//         style={{
//           ...display,
//           fontWeight: 700,
//           color: C.maroon,
//           fontSize: "1.7rem",
//         }}
//         className="mb-2"
//       >
//         Payment Successful!
//       </h2>
//       <p className="small mb-4" style={{ color: C.taupe }}>
//         How would you like to proceed with your Vastu report?
//       </p>

//       {error && (
//         <Alert
//           style={{
//             background: "#FDEDED",
//             color: "#B23A3A",
//             fontSize: "0.85rem",
//           }}
//         >
//           {error}
//         </Alert>
//       )}

//       <div className="d-flex flex-column gap-3">
//         <button
//           onClick={onContinue}
//           disabled={generating}
//           className="position-relative rounded-4 p-4 text-start border-0"
//           style={{
//             background: C.maroon,
//             color: "#fff",
//             opacity: generating ? 0.7 : 1,
//           }}
//         >
//           <div className="fs-3 mb-2">⚡</div>
//           <div className="fw-semibold mb-1">
//             {generating ? (
//               <span className="d-inline-flex align-items-center gap-2">
//                 <Spin size="small" /> Generating…
//               </span>
//             ) : (
//               "Generate Report Now"
//             )}
//           </div>
//           <div className="small" style={{ color: "#F5C97A" }}>
//             Recommended — Will immediately generate your comprehensive Vastu
//             report
//           </div>
//           <span
//             className="position-absolute top-0 end-0 mt-3 me-3 rounded-pill px-2 py-1 small fw-bold"
//             style={{ background: C.gold, color: "#fff" }}
//           >
//             Default
//           </span>
//         </button>
//         {/* <button
//           onClick={onValidate}
//           disabled={generating}
//           className="bg-white rounded-4 p-4 text-start"
//           style={{ border: `2px solid ${C.border}` }}
//         >
//           <div className="fs-3 mb-2">📝</div>
//           <div className="fw-semibold mb-1" style={{ color: C.maroon }}>
//             Validate Data First
//           </div>
//           <div className="small" style={{ color: C.taupe }}>
//             Review and edit the extracted information before generating the
//             report
//           </div>
//         </button> */}
//       </div>
//     </div>
//   );
// }

// /* ================== SCREEN — Validate extracted data ===================== */
// function StepValidateData({
//   ocrData,
//   doorPosition,
//   onGenerate,
//   generating,
//   error,
// }) {
//   const token = window.sessionStorage.getItem("token");
//   const [directions, setDirections] = useState([]);
//   const [rooms, setRooms] = useState([]);
//   const [floorCount, setFloorCount] = useState(0);

//   // const handleConfirm = () => {
//   //   if (!ocrData) return;

//   //   let roomIndex = 0;
//   //   const updatedFloors = (ocrData.elementDetails?.floorDetails || []).map(
//   //     (floor) => ({
//   //       ...floor,
//   //       elementDetails: (floor.elementDetails || []).map((el) => {
//   //         const edited = rooms[roomIndex++];
//   //         return edited
//   //           ? { ...el, elementName: edited.name.toUpperCase() }
//   //           : el;
//   //       }),
//   //     }),
//   //   );

//   //   const payload = {
//   //     ...ocrData,
//   //     elementDetails: {
//   //       ...ocrData.elementDetails,
//   //       floorDetails: updatedFloors,
//   //     },
//   //   };

//   //   onGenerate(payload);
//   // };

//   const handleConfirm = () => {
//     if (!ocrData) return;

//     let roomIndex = 0;
//     const updatedFloors = (ocrData.elementDetails?.floorDetails || []).map(
//       (floor) => ({
//         ...floor,
//         elementDetails: (floor.elementDetails || []).map((el) => {
//           const edited = rooms[roomIndex++];
//           return edited
//             ? {
//               ...el,
//               elementName: edited.name.toUpperCase(),
//               elementDirectionId: edited.directionId,
//               width: edited.width,
//               length: edited.length,
//             }
//             : el;
//         }),
//       }),
//     );

//     const payload = {
//       ...ocrData,
//       elementDetails: {
//         ...ocrData.elementDetails,
//         floorDetails: updatedFloors,
//       },
//     };

//     onGenerate(payload);
//   };

//   useEffect(() => {
//     const fetchDirections = async () => {
//       try {
//         const res = await vasthuUrl.get("/getdirections", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setDirections(
//           Array.isArray(res.data) ? res.data : res.data?.data || [],
//         );
//       } catch (err) {
//         console.error("Directions fetch error:", err);
//       }
//     };
//     fetchDirections();
//   }, []);

//   useEffect(() => {
//     const floors = ocrData?.elementDetails?.floorDetails || [];
//     setFloorCount(floors.length);

//     const flatRooms = floors.flatMap((floor) =>
//       (floor.elementDetails || []).map((el) => ({
//         name: formatElementName(el.elementName),
//         directionId: el.elementDirectionId,
//         width: el.width,
//         length: el.length,
//         floorName: floor.floorName,
//       })),
//     );
//     setRooms(flatRooms);
//   }, [ocrData]);

//   const directionName = (id) =>
//     directions.find((d) => d.id === id)?.name || `Direction ${id}`;

//   return (
//     <div className="mx-auto px-3 py-4" style={{ maxWidth: 560 }}>
//       <VastuCard>
//         <GoldHeading sub="Review and confirm the extracted floor plan data">
//           Validate Extracted Data
//         </GoldHeading>

//         {error && (
//           <Alert
//             className="mb-3"
//             style={{
//               background: "#FDEDED",
//               color: "#B23A3A",
//               fontSize: "0.85rem",
//             }}
//           >
//             {error}
//           </Alert>
//         )}

//         <div className="d-flex flex-column gap-2 mb-4">
//           {rooms.map((room, i) => (
//             <div
//               key={i}
//               className="d-flex align-items-center gap-3 rounded-3 px-3 py-2"
//               style={{ background: C.sand, border: `1px solid ${C.border}` }}
//             >
//               <span className="fs-5">🏠</span>
//               <div className="flex-grow-1 min-w-0">
//                 <input
//                   value={room.name}
//                   onChange={(e) => {
//                     const next = [...rooms];
//                     next[i] = { ...room, name: e.target.value };
//                     setRooms(next);
//                   }}
//                   className="fw-semibold small w-100 border-0 bg-transparent"
//                   style={{ outline: "none", color: C.ink }}
//                 />
//                 {/* <div className="small" style={{ color: C.taupe }}>
//                   {directionName(room.directionId)} · {room.width}×{room.length}{" "}
//                   ft
//                   {rooms.some((r) => r.floorName !== room.floorName) &&
//                     ` · ${room.floorName}`}
//                 </div> */}
//                 <div
//                   className="d-flex align-items-center flex-wrap gap-1 small"
//                   style={{ color: C.taupe }}
//                 >
//                   <select
//                     value={room.directionId ?? ""}
//                     onChange={(e) => {
//                       const next = [...rooms];
//                       next[i] = {
//                         ...room,
//                         directionId: Number(e.target.value),
//                       };
//                       setRooms(next);
//                     }}
//                     className="border-0 bg-transparent"
//                     style={{
//                       color: C.taupe,
//                       fontSize: "inherit",
//                       outline: "none",
//                     }}
//                   >
//                     {directions.map((d) => (
//                       <option key={d.id} value={d.id}>
//                         {d.name}
//                       </option>
//                     ))}
//                   </select>
//                   <span>·</span>
//                   <input
//                     type="number"
//                     value={room.width}
//                     onChange={(e) => {
//                       const next = [...rooms];
//                       next[i] = { ...room, width: e.target.value };
//                       setRooms(next);
//                     }}
//                     className="border-0 bg-transparent"
//                     style={{ width: 40, color: C.taupe, outline: "none" }}
//                   />
//                   <span>×</span>
//                   <input
//                     type="number"
//                     value={room.length}
//                     onChange={(e) => {
//                       const next = [...rooms];
//                       next[i] = { ...room, length: e.target.value };
//                       setRooms(next);
//                     }}
//                     className="border-0 bg-transparent"
//                     style={{ width: 40, color: C.taupe, outline: "none" }}
//                   />
//                   <span>ft</span>
//                   {rooms.some((r) => r.floorName !== room.floorName) && (
//                     <>
//                       <span>·</span>
//                       <span>{room.floorName}</span>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//         <div
//           className="rounded-3 p-3 mb-3 small"
//           style={{
//             background: C.creamCard,
//             border: `1px solid ${C.border}`,
//             color: C.taupe,
//           }}
//         >
//           Detected{" "}
//           <span className="fw-bold" style={{ color: C.maroon }}>
//             {floorCount} floor{floorCount !== 1 ? "s" : ""}
//           </span>
//           ,{" "}
//           <span className="fw-bold" style={{ color: C.maroon }}>
//             {rooms.length} rooms
//           </span>
//           {doorPosition && (
//             <>
//               , and{" "}
//               <span className="fw-bold" style={{ color: C.maroon }}>
//                 {doorPosition} main entrance
//               </span>
//             </>
//           )}
//           . Edit any field above if incorrect.
//         </div>
//         <PrimaryBtn
//           onClick={handleConfirm}
//           disabled={generating}
//           fullWidth
//           variant="gold"
//         >
//           {generating ? (
//             <span className="d-inline-flex align-items-center gap-2">
//               <Spin size="small" /> Generating Report…
//             </span>
//           ) : (
//             "Confirm & Generate Report →"
//           )}
//         </PrimaryBtn>
//       </VastuCard>
//     </div>
//   );
// }

// /* =============== SCREEN — Generating report=============================== */
// function StepGenerating({ onDone }) {
//   const [phase, setPhase] = useState(0);
//   const ITEMS = [
//     "Mapping directional energies…",
//     "Calculating Vastu score…",
//     "Identifying defects…",
//     "Generating corrections…",
//     "Composing report…",
//   ];

//   useEffect(() => {
//     let i = 0;
//     const t = setInterval(() => {
//       i++;
//       setPhase(i);
//       if (i >= ITEMS.length) {
//         clearInterval(t);
//         setTimeout(onDone, 800);
//       }
//     }, 1000);
//     return () => clearInterval(t);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <div className="mx-auto px-3 py-5 text-center" style={{ maxWidth: 460 }}>
//       <div
//         className="mx-auto mb-4 position-relative"
//         style={{ width: 128, height: 128 }}
//       >
//         <div
//           className="position-absolute top-0 start-0 w-100 h-100 rounded-circle"
//           style={{ background: "#FFF3DC", border: `4px solid ${C.gold}` }}
//         />
//         <div
//           className="position-absolute rounded-circle"
//           style={{
//             inset: 8,
//             border: `2px dashed rgba(123,30,30,.27)`,
//             animation: "spin 4s linear infinite",
//           }}
//         />
//         <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center fs-1">
//           ✨
//         </div>
//       </div>
//       <h2
//         style={{
//           ...display,
//           fontWeight: 700,
//           color: C.maroon,
//           fontSize: "1.7rem",
//         }}
//         className="mb-4"
//       >
//         Generating Vastu Report
//       </h2>
//       <div
//         className="d-flex flex-column gap-2 text-start mx-auto"
//         style={{ maxWidth: 320 }}
//       >
//         {ITEMS.map((item, i) => (
//           <div
//             key={i}
//             className="d-flex align-items-center gap-2 small"
//             style={{
//               color:
//                 i < phase ? C.gold : i === phase ? C.maroon : C.placeholder,
//               fontWeight: i === phase ? 600 : 400,
//             }}
//           >
//             <span>{i < phase ? "✓" : i === phase ? "⟳" : "○"}</span>
//             {item}
//           </div>
//         ))}
//       </div>
//       <style>{"@keyframes spin { to { transform: rotate(360deg); } }"}</style>
//     </div>
//   );
// }

// /* =============== SCREEN — Final report ================================== */
// function formatFloorName(name = "") {
//   return name
//     .split("-")
//     .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
//     .join(" ");
// }

// // Derives a 0-100 score from the pass/fail flags present in the response.
// // ⚠️ CONFIRM: replace with backend-provided score field if one exists.
// function computeScore(reportData) {
//   if (!reportData) return 0;
//   const checks = [
//     reportData.house?.mainDoorPlacementResult,
//     reportData.level?.south_Vs_north,
//     reportData.level?.southWest_Vs_northEast,
//     reportData.level?.west_Vs_east,
//     reportData.window?.result,
//   ].filter((v) => typeof v === "boolean");

//   if (checks.length === 0) return 0;
//   const passed = checks.filter(Boolean).length;
//   return Math.round((passed / checks.length) * 100);
// }

// const BORDER = "#f0b955";

// // mobile card list - each row becomes a stacked label:value card,
// // used below the md breakpoint instead of the wide antd Table
// const MobileCardList = ({ columns, dataSource, emptyText }) => {
//   if (!dataSource || dataSource.length === 0) {
//     return (
//       <div
//         className="d-md-none small text-center py-2"
//         style={{ color: "#888" }}
//       >
//         {emptyText || "No data"}
//       </div>
//     );
//   }
//   return (
//     <div className="d-md-none d-flex flex-column gap-2">
//       {dataSource.map((row) => (
//         <div
//           key={row.key}
//           style={{
//             border: `1px solid ${BORDER}`,
//             borderRadius: 6,
//             padding: "8px 12px",
//             background: "#fff",
//           }}
//         >
//           {columns.map((col) => (
//             <div
//               key={col.key}
//               className="d-flex justify-content-between align-items-center py-1"
//               style={{
//                 borderBottom: "1px dashed #eee",
//                 gap: 12,
//                 flexDirection: "row",
//               }}
//             >
//               <span
//                 style={{
//                   fontWeight: 600,
//                   fontSize: 12,
//                   color: "#666",
//                   flexShrink: 0,
//                 }}
//               >
//                 {col.title}
//               </span>
//               <span style={{ fontSize: 13, textAlign: "right" }}>
//                 {col.render
//                   ? col.render(row[col.dataIndex], row)
//                   : row[col.dataIndex] ?? "-"}
//               </span>
//             </div>
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// };

// // Table on desktop (md+), stacked cards on mobile - same columns/dataSource
// // drive both, so every section only needs to be defined once
// const ResponsiveTable = ({ columns, dataSource, emptyText, ...rest }) => (
//   <>
//     <div className="d-none d-md-block">
//       <Table
//         columns={columns}
//         dataSource={dataSource}
//         pagination={false}
//         bordered
//         size="middle"
//         locale={{ emptyText }}
//         {...rest}
//       />
//     </div>
//     <MobileCardList
//       columns={columns}
//       dataSource={dataSource}
//       emptyText={emptyText}
//     />
//   </>
// );

// /* ---------------------------------------------------------------------
//    DASHBOARD-STYLE REPORT UI (score ring, badges, tabs, section cards)
//    Same reportData shape: house / window / level / element / misc
//    --------------------------------------------------------------------- */

// const R = {
//   header: "linear-gradient(135deg,#F7B733 0%,#F2A71B 100%)",
//   good: "#1F9254",
//   goodBg: "#E9F7EF",
//   bad: "#D64545",
//   badBg: "#FDEBEB",
//   warnBg: "#FFF6E3",
//   warnBorder: "#F3D08A",
//   card: "#FFFFFF",
//   cardBorder: "#EFE3CE",
//   muted: "#8B7358",
//   ink: "#2D1A0E",
// };

// /* status pill (Good / Not Good / custom labels) */
// function StatusPill({ ok, label }) {
//   const text = label || (ok ? "Good" : "Not Good");
//   const good = /good|excellent/i.test(text) && !/not good/i.test(text);
//   return (
//     <span
//       style={{
//         fontWeight: 700,
//         fontSize: 12.5,
//         padding: "3px 10px",
//         borderRadius: 999,
//         color: good ? R.good : R.bad,
//         background: good ? R.goodBg : R.badBg,
//         whiteSpace: "nowrap",
//       }}
//     >
//       {text}
//     </span>
//   );
// }

// /* score ring + verdict text */
// function scoreMeta(score) {
//   if (score >= 80)
//     return {
//       label: "Excellent",
//       color: R.good,
//       desc: "Your building follows Vastu principles well.",
//     };
//   if (score >= 60)
//     return {
//       label: "Good",
//       color: "#3C8DBC",
//       desc:
//         "Your building is mostly Vastu compliant with minor points to note.",
//     };
//   if (score >= 40)
//     return {
//       label: "Needs Attention",
//       color: "#E39A2A",
//       desc:
//         "Your building has some important Vastu issues that need correction.",
//     };
//   return {
//     label: "Poor",
//     color: R.bad,
//     desc: "Your building has significant Vastu issues that need correction.",
//   };
// }

// function ScoreRing({ score }) {
//   const meta = scoreMeta(score);
//   return (
//     <div className="d-flex align-items-center gap-3">
//       <div style={{ width: 110, height: 110, position: "relative" }}>
//         <Progress
//           type="circle"
//           percent={score}
//           size={110}
//           strokeColor={meta.color}
//           trailColor="#EFE6D8"
//           format={() => (
//             <div style={{ lineHeight: 1.1 }}>
//               <div style={{ fontSize: 26, fontWeight: 800, color: R.ink }}>
//                 {score}
//               </div>
//               <div style={{ fontSize: 11, color: R.muted }}>/100</div>
//             </div>
//           )}
//         />
//       </div>
//       <div>
//         <div
//           style={{
//             fontSize: 12,
//             fontWeight: 700,
//             letterSpacing: "0.06em",
//             color: R.muted,
//             textTransform: "uppercase",
//           }}
//         >
//           Overall Vastu Score
//         </div>
//         <div
//           style={{
//             fontSize: 22,
//             fontWeight: 800,
//             color: meta.color,
//             ...display,
//           }}
//         >
//           {meta.label}
//         </div>
//         <div style={{ fontSize: 13, color: R.muted, maxWidth: 260 }}>
//           {meta.desc}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* Karam / Profit&Loss / Yoni / Age badge row */
// function AyadiBadgeRow({ house }) {
//   // ⚠️ CONFIRM: falls back across 8x8 / 9x9 grid objects — adjust keys if backend differs
//   const grid = house?.eightGridObj || house?.nineGridObj || {};
//   const items = [
//     { key: "karpam", label: "karpam", icon: "❁" },
//     { key: "profitLoss", label: "Profit & Loss", icon: "₹" },
//     { key: "yoni", label: "Yoni", icon: "🐄" },
//     { key: "age", label: "Age Factor", icon: "👤" },
//   ];
//   return (
//     <div className="d-flex flex-wrap gap-4">
//       {items.map((it) => {
//         const ok = !!grid[it.key];
//         return (
//           <div key={it.key} className="d-flex align-items-center gap-2">
//             <div
//               style={{
//                 width: 34,
//                 height: 34,
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 16,
//                 background: ok ? R.goodBg : R.badBg,
//                 color: ok ? R.good : R.bad,
//               }}
//             >
//               {it.icon}
//             </div>
//             <div>
//               <div style={{ fontSize: 13, fontWeight: 700, color: R.ink }}>
//                 {it.label}
//               </div>
//               <StatusPill ok={ok} />
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// /* generic overview summary card (Rooms / Windows / Misc / Leveling) */
// function SummaryCard({ index, title, checked, issues, onView, illustration }) {
//   const hasIssue = issues > 0;
//   return (
//     <VastuCard style={{ padding: "1.1rem" }}>
//       <div className="d-flex align-items-center gap-2 mb-3">
//         <span
//           style={{
//             width: 22,
//             height: 22,
//             borderRadius: "50%",
//             background: C.gold,
//             color: "#fff",
//             fontSize: 12,
//             fontWeight: 700,
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           {index}
//         </span>
//         <span style={{ fontWeight: 700, color: R.ink, fontSize: 15 }}>
//           {title}
//         </span>
//       </div>
//       <div className="d-flex gap-3">
//         {illustration}
//         <div className="flex-grow-1 small" style={{ color: R.ink }}>
//           <div className="d-flex justify-content-between py-1">
//             <span style={{ color: R.muted }}>{title} Checked</span>
//             <span style={{ fontWeight: 700 }}>{checked}</span>
//           </div>
//           <div className="d-flex justify-content-between py-1">
//             <span style={{ color: R.muted }}>Issues Found</span>
//             <span style={{ fontWeight: 700, color: hasIssue ? R.bad : R.good }}>
//               {issues}
//             </span>
//           </div>
//           <div className="d-flex justify-content-between align-items-center py-1">
//             <span style={{ color: R.muted }}>Overall Status</span>
//             <StatusPill
//               ok={!hasIssue}
//               label={hasIssue ? "Needs Attention" : "Good"}
//             />
//           </div>
//         </div>
//       </div>
//       {onView && (
//         <button
//           onClick={onView}
//           className="btn btn-link p-0 mt-2 small fw-semibold text-decoration-none"
//           style={{ color: C.gold }}
//         >
//           View {title} Analysis →
//         </button>
//       )}
//     </VastuCard>
//   );
// }

// function StepReport({
//   ownerName,
//   reportData,
//   buildingArea,
//   perimeter,
//   onReview,
// }) {
//   const [tab, setTab] = useState("overview");
//   const [showIssues, setShowIssues] = useState(false);

//   const house = reportData?.house;
//   const windowResult = reportData?.window;
//   const level = reportData?.level;
//   const element = reportData?.element;
//   const misc = reportData?.misc;

//   const floorEntries = element ? Object.entries(element) : [];
//   const allRooms = floorEntries.flatMap(([floorName, rooms]) =>
//     (rooms || []).map((r) => ({ ...r, floorName })),
//   );

//   // const miscData = (misc || []).map((m, i) => ({
//   //   key: `misc-${i}`,
//   //   name: m.name ?? m.elementName ?? `Item ${i + 1}`,
//   //   result: m.result ?? m.status ?? false,
//   // }));

//   // const miscData = (Array.isArray(misc) ? misc : []).map((m, i) => ({
//   //   key: `misc-${i}`,
//   //   name: m.name ?? m.elementName ?? `Item ${i + 1}`,
//   //   result: m.result ?? m.status ?? false,
//   // }));


//   const miscData = (Array.isArray(misc) ? misc : []).map((m, i) => ({
//     key: `misc-${i}`,

//     name:
//       m.miscellaneousName ??
//       m.name ??
//       m.elementName ??
//       `Item ${i + 1}`,

//     location:
//       m.miscellaneousLocation ??
//       m.location ??
//       "",

//     result:
//       typeof m.miscellaneousLocationResult === "string"
//         ? /good/i.test(m.miscellaneousLocationResult)
//         : Boolean(m.miscellaneousLocationResult ?? m.result ?? m.status),
//   }));












//   const levelRows = [
//     { key: "sw_ne", name: "SW vs NE", result: !!level?.southWest_Vs_northEast },
//     { key: "w_e", name: "W vs E", result: !!level?.west_Vs_east },
//     { key: "s_n", name: "S vs N", result: !!level?.south_Vs_north },
//   ];

//   const score = computeScore(reportData);

//   /* collect a flat issue list across every section (for "View All Issues") */
//   const issues = [];
//   if (
//     house?.buildingFrontWidthResult &&
//     !/good/i.test(String(house.buildingFrontWidthResult))
//   )
//     issues.push({
//       section: "Main Entrance",
//       text: `Building Width — ${house.buildingFrontWidthResult}`,
//     });
//   if (
//     house?.mainDoorFacingResult &&
//     !/good/i.test(String(house.mainDoorFacingResult))
//   )
//     issues.push({
//       section: "Main Entrance",
//       text: `Main Facing — ${house.mainDoorFacingResult}`,
//     });
//   if (house && !house.mainDoorPlacementResult)
//     issues.push({
//       section: "Main Entrance",
//       text: "Door Placement — Unfavorable",
//     });
//   allRooms.forEach((r) => {
//     if (r.widthStatus && !/good/i.test(String(r.widthStatus)))
//       issues.push({
//         section: "Rooms",
//         text: `${r.elementName || "Room"} — width ${r.widthStatus}`,
//       });
//     if (r.directionStatus && !/good/i.test(String(r.directionStatus)))
//       issues.push({
//         section: "Rooms",
//         text: `${r.elementName || "Room"} — direction ${r.directionStatus}`,
//       });
//   });
//   if (windowResult && !windowResult.result)
//     issues.push({
//       section: "Windows",
//       text: "Window placement needs correction",
//     });
//   levelRows.forEach((l) => {
//     if (!l.result)
//       issues.push({ section: "Leveling", text: `${l.name} — Bad` });
//   });
//   miscData.forEach((m) => {
//     if (!m.result)
//       issues.push({ section: "Other Factors", text: `${m.name} — Not Good` });
//   });

//   const roomIssueCount = allRooms.filter(
//     (r) =>
//       (r.widthStatus && !/good/i.test(String(r.widthStatus))) ||
//       (r.directionStatus && !/good/i.test(String(r.directionStatus))),
//   ).length;
//   const windowIssueCount = windowResult && !windowResult.result ? 1 : 0;
//   const miscIssueCount = miscData.filter((m) => !m.result).length;
//   const levelIssueCount = levelRows.filter((l) => !l.result).length;

//   const TabBtn = ({ id, label }) => (
//     <button
//       onClick={() => setTab(id)}
//       className="btn btn-sm border-0 fw-semibold"
//       style={{
//         color: tab === id ? C.maroon : R.muted,
//         borderBottom:
//           tab === id ? `2px solid ${C.gold}` : "2px solid transparent",
//         borderRadius: 0,
//         padding: "8px 14px",
//         background: "transparent",
//       }}
//     >
//       {label}
//     </button>
//   );

//   return (
//     <div style={{ background: C.cream, minHeight: "100vh" }}>
//       {/* ---------- header ---------- */}
//       <div style={{ background: R.header, padding: "1.5rem 1.25rem 4.5rem" }}>
//         <div className="d-flex justify-content-between align-items-start">
//           <div>
//             <div
//               style={{
//                 ...display,
//                 fontWeight: 800,
//                 fontSize: "1.5rem",
//                 color: "#3B2400",
//               }}
//             >
//               {ownerName || "Your"}'s Home
//             </div>
//             <div
//               className="d-flex gap-3 mt-1 small"
//               style={{ color: "#5C3B00" }}
//             >
//               <span>📐 Building Area: {buildingArea ?? "—"} sq.ft</span>
//               <span>📏 Perimeter: {perimeter ?? "—"} sq.ft</span>
//             </div>
//           </div>
//           {onReview && (
//             <button
//               onClick={onReview}
//               className="btn btn-sm bg-white fw-semibold"
//               style={{ borderRadius: 10, color: C.maroon }}
//             >
//               ⭐ Rate this report
//             </button>
//           )}
//         </div>
//       </div>

//       <div
//         // style={{ margin: "-3.5rem 1.25rem 0", position: "relative", zIndex: 2 }}
//         style={{ margin: "-3.5rem 1.25rem 0" }}
//       >
//         {/* ---------- score + ayadi card ---------- */}
//         <VastuCard>
//           <div className="d-flex flex-wrap justify-content-between gap-4">
//             {/* <ScoreRing score={score} /> */}
//             <AyadiBadgeRow house={house} />
//           </div>
//         </VastuCard>

//         {/* ---------- key issues banner ---------- */}
//         <div
//           className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 p-3"
//           style={{
//             background: R.warnBg,
//             border: `1px solid ${R.warnBorder}`,
//             borderRadius: 14,
//           }}
//         >
//           <div className="d-flex align-items-center gap-2">
//             <span style={{ fontSize: 20 }}>⚠️</span>
//             <div>
//               <div style={{ fontWeight: 700, color: R.ink }}>
//                 Key Issues Found
//               </div>
//               <div className="small" style={{ color: R.muted }}>
//                 {issues.length} important issue{issues.length !== 1 ? "s" : ""}{" "}
//                 need your attention.
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={() => setShowIssues((s) => !s)}
//             className="btn btn-sm fw-semibold"
//             style={{
//               border: `1px solid ${C.gold}`,
//               color: C.gold,
//               borderRadius: 10,
//               background: "#fff",
//             }}
//           >
//             {showIssues ? "Hide Issues" : "View All Issues"} →
//           </button>
//         </div>

//         {showIssues && (
//           <div
//             className="mt-2 p-3"
//             style={{
//               background: "#fff",
//               border: `1px solid ${C.border}`,
//               borderRadius: 14,
//             }}
//           >
//             {issues.length === 0 ? (
//               <div className="small text-center" style={{ color: R.muted }}>
//                 No outstanding issues 🎉
//               </div>
//             ) : (
//               <div className="d-flex flex-column gap-2">
//                 {issues.map((it, i) => (
//                   <div
//                     key={i}
//                     className="d-flex justify-content-between small py-1"
//                     style={{ borderBottom: "1px dashed #eee" }}
//                   >
//                     <span style={{ color: R.muted }}>{it.section}</span>
//                     <span style={{ color: R.bad, fontWeight: 600 }}>
//                       {it.text}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//         {/* ---------- tabs ---------- */}
//         <div
//           className="d-flex flex-wrap mt-3"
//           style={{ borderBottom: `1px solid ${C.border}` }}
//         >
//           <TabBtn id="overview" label="🏠 Overview" />
//           <TabBtn id="entrance" label="🚪 Main Entrance" />
//           <TabBtn id="rooms" label="🛏️ Rooms" />
//           <TabBtn id="windows" label="🪟 Windows" />
//           <TabBtn id="leveling" label="⛰️ Leveling" />
//           <TabBtn id="misc" label="📋 Other Factors" />
//         </div>

//         <div className="py-3">
//           {/* ================= OVERVIEW ================= */}
//           {tab === "overview" && (
//             <div className="d-flex flex-column gap-3">
//               {/* Main entrance — big card */}
//               <VastuCard>
//                 <div className="d-flex align-items-center gap-2 mb-3">
//                   <span
//                     style={{
//                       width: 22,
//                       height: 22,
//                       borderRadius: "50%",
//                       background: C.gold,
//                       color: "#fff",
//                       fontSize: 12,
//                       fontWeight: 700,
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     1
//                   </span>
//                   <span style={{ fontWeight: 700, color: R.ink, fontSize: 15 }}>
//                     Main Entrance
//                   </span>
//                 </div>
//                 <div className="d-flex flex-wrap gap-3">
//                   <SectionImage
//                     src="/images/main_door.png"
//                     alt="Main Door"
//                     size={150}
//                   />
//                   <div className="flex-grow-1" style={{ minWidth: 200 }}>
//                     <div
//                       className="d-flex justify-content-between align-items-center py-2"
//                       style={{ borderBottom: "1px solid #F1EAD8" }}
//                     >
//                       <div>
//                         <div
//                           style={{
//                             fontWeight: 600,
//                             fontSize: 13.5,
//                             color: R.ink,
//                           }}
//                         >
//                           Building Width
//                         </div>
//                         <div className="small" style={{ color: R.muted }}>
//                           {house?.buildingFrontWidthResult || "—"}
//                         </div>
//                       </div>
//                       <StatusPill
//                         ok={/good/i.test(
//                           String(house?.buildingFrontWidthResult),
//                         )}
//                         label={house?.buildingFrontWidthResult}
//                       />
//                     </div>
//                     <div
//                       className="d-flex justify-content-between align-items-center py-2"
//                       style={{ borderBottom: "1px solid #F1EAD8" }}
//                     >
//                       <div>
//                         <div
//                           style={{
//                             fontWeight: 600,
//                             fontSize: 13.5,
//                             color: R.ink,
//                           }}
//                         >
//                           Main Facing
//                         </div>
//                         <div className="small" style={{ color: R.muted }}>
//                           {house?.mainDoorFacingResult || "—"}
//                         </div>
//                       </div>
//                       <StatusPill
//                         ok={/good/i.test(String(house?.mainDoorFacingResult))}
//                         label={house?.mainDoorFacingResult}
//                       />
//                     </div>
//                     <div className="d-flex justify-content-between align-items-center py-2">
//                       <div>
//                         <div
//                           style={{
//                             fontWeight: 600,
//                             fontSize: 13.5,
//                             color: R.ink,
//                           }}
//                         >
//                           Door Placement
//                         </div>
//                         <div className="small" style={{ color: R.muted }}>
//                           {house?.mainDoorPlacementResult
//                             ? "Favorable"
//                             : "Unfavorable"}
//                         </div>
//                       </div>
//                       <StatusPill ok={!!house?.mainDoorPlacementResult} />
//                     </div>
//                   </div>
//                   <div
//                     className="p-3"
//                     style={{
//                       background: R.warnBg,
//                       border: `1px solid ${R.warnBorder}`,
//                       borderRadius: 14,
//                       minWidth: 220,
//                       flex: "1 1 220px",
//                     }}
//                   >
//                     <div className="d-flex align-items-center gap-2 mb-1">
//                       <span>💡</span>
//                       <span
//                         style={{
//                           fontWeight: 700,
//                           color: R.ink,
//                           fontSize: 13.5,
//                         }}
//                       >
//                         Recommendation
//                       </span>
//                     </div>
//                     <div className="small" style={{ color: R.muted }}>
//                       Main door placement and building width are not as per
//                       Vastu principles. Consider the suggested corrections.
//                     </div>
//                     <button
//                       onClick={() => setTab("entrance")}
//                       className="btn btn-sm mt-2 fw-semibold"
//                       style={{
//                         background: C.gold,
//                         color: "#fff",
//                         borderRadius: 10,
//                       }}
//                     >
//                       View Details →
//                     </button>
//                   </div>
//                 </div>
//               </VastuCard>

//               {/* 2x2 summary cards */}
//               <div className="row g-3">
//                 <div className="col-12 col-md-6">
//                   <SummaryCard
//                     index={2}
//                     title="Rooms"
//                     checked={allRooms.length}
//                     issues={roomIssueCount}
//                     onView={() => setTab("rooms")}
//                     illustration={
//                       <SectionImage
//                         src="/images/Rooms.png"
//                         alt="Rooms"
//                         size={84}
//                       />
//                     }
//                   />
//                 </div>

//                 <div className="col-12 col-md-6">
//                   <SummaryCard
//                     index={3}
//                     title="Windows"
//                     checked={windowResult ? 1 : 0}
//                     issues={windowIssueCount}
//                     onView={() => setTab("windows")}
//                     illustration={
//                       <SectionImage
//                         src="/images/window.png"
//                         alt="Windows"
//                         size={84}
//                       />
//                     }
//                   />
//                 </div>

//                 <div className="col-12 col-md-6">
//                   <SummaryCard
//                     index={4}
//                     title="Other Factors"
//                     checked={miscData.length}
//                     issues={miscIssueCount}
//                     onView={() => setTab("misc")}
//                     illustration={
//                       <SectionImage
//                         src="/images/misc.png"
//                         alt="Other Factors"
//                         size={84}
//                       />
//                     }
//                   />
//                 </div>

//                 <div className="col-12 col-md-6">
//                   <SummaryCard
//                     index={5}
//                     title="Leveling"
//                     checked={levelRows.length}
//                     issues={levelIssueCount}
//                     onView={() => setTab("leveling")}
//                     illustration={
//                       <SectionImage
//                         src="/images/leveling.png"
//                         alt="Leveling"
//                         size={84}
//                       />
//                     }
//                   />
//                 </div>
//               </div>

//               {/* overall recommendation footer */}
//               <div
//                 className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3"
//                 style={{
//                   background: R.goodBg,
//                   border: `1px solid #BFE3CC`,
//                   borderRadius: 14,
//                 }}
//               >
//                 <div className="d-flex align-items-center gap-2">
//                   <CheckCircleFilled style={{ color: R.good, fontSize: 22 }} />
//                   <div>
//                     <div style={{ fontWeight: 700, color: R.ink }}>
//                       Overall Recommendation
//                     </div>
//                     <div
//                       className="small"
//                       style={{ color: R.muted, maxWidth: 520 }}
//                     >
//                       Your building has{" "}
//                       {issues.length
//                         ? "several Vastu imbalances that may affect health, wealth and prosperity"
//                         : "good Vastu alignment"}
//                       . We recommend making the above corrections to bring
//                       positive energy and harmony.
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ================= MAIN ENTRANCE ================= */}
//           {tab === "entrance" && (
//             <VastuCard>
//               <div className="d-flex flex-wrap gap-4">
//                 <SectionImage
//                   src="/images/main_door.png"
//                   alt="main_door"
//                   size={200}
//                 />
//                 <ResponsiveTable
//                   columns={[
//                     {
//                       title: "Building Width",
//                       dataIndex: "width",
//                       key: "width",
//                       render: (v) => (
//                         <StatusPill ok={/good/i.test(String(v))} label={v} />
//                       ),
//                     },
//                     {
//                       title: "Main Facing",
//                       dataIndex: "facing",
//                       key: "facing",
//                       render: (v) => (
//                         <StatusPill ok={/good/i.test(String(v))} label={v} />
//                       ),
//                     },
//                     {
//                       title: "Door Placement",
//                       dataIndex: "placement",
//                       key: "placement",
//                       render: (v) => <StatusPill ok={v} />,
//                     },
//                   ]}
//                   dataSource={[
//                     {
//                       key: "main-door",
//                       width: house?.buildingFrontWidthResult,
//                       facing: house?.mainDoorFacingResult,
//                       placement: house?.mainDoorPlacementResult,
//                     },
//                   ]}
//                 />
//               </div>
//             </VastuCard>
//           )}

//           {/* ================= ROOMS ================= */}
//           {tab === "rooms" && (
//             <div className="d-flex flex-column gap-3">
//               {floorEntries.length === 0 && (
//                 <VastuCard>
//                   <div className="small text-center" style={{ color: R.muted }}>
//                     No room data available
//                   </div>
//                 </VastuCard>
//               )}
//               {floorEntries.map(([floorName, rooms]) => (
//                 <VastuCard
//                   key={floorName}
//                   style={{ padding: 0, overflow: "hidden" }}
//                 >
//                   <div
//                     style={{
//                       background: C.gold,
//                       color: "#fff",
//                       fontWeight: 700,
//                       padding: "10px 16px",
//                     }}
//                   >
//                     {formatFloorName(floorName)}
//                   </div>
//                   <div className="p-3">
//                     <ResponsiveTable
//                       columns={[
//                         {
//                           title: "Element",
//                           dataIndex: "elementName",
//                           key: "elementName",
//                         },
//                         {
//                           title: "Width",
//                           dataIndex: "roomWidth",
//                           key: "roomWidth",
//                         },
//                         {
//                           title: "Width Status",
//                           dataIndex: "widthStatus",
//                           key: "widthStatus",
//                           render: (v) => (
//                             <StatusPill
//                               ok={/good/i.test(String(v))}
//                               label={v}
//                             />
//                           ),
//                         },
//                         {
//                           title: "Direction",
//                           dataIndex: "directionName",
//                           key: "directionName",
//                         },
//                         {
//                           title: "Direction Status",
//                           dataIndex: "directionStatus",
//                           key: "directionStatus",
//                           render: (v) => (
//                             <StatusPill
//                               ok={/good/i.test(String(v))}
//                               label={v}
//                             />
//                           ),
//                         },
//                       ]}
//                       dataSource={(rooms || []).map((r, i) => ({
//                         key: `${floorName}-${i}`,
//                         ...r,
//                       }))}
//                     />
//                   </div>
//                 </VastuCard>
//               ))}
//             </div>
//           )}

//           {/* ================= WINDOWS ================= */}
//           {tab === "windows" && (
//             <VastuCard>
//               <div className="d-flex flex-wrap gap-4 align-items-center">
//                 <SectionImage
//                   src="/images/window.png"
//                   alt="Windows"
//                   size={200}
//                 />
//                 <div className="flex-grow-1">
//                   <div
//                     className="d-flex justify-content-between align-items-center py-2"
//                     style={{ borderBottom: "1px solid #F1EAD8" }}
//                   >
//                     <span style={{ color: R.muted }}>
//                       Overall Window Result
//                     </span>
//                     <StatusPill ok={!!windowResult?.result} />
//                   </div>
//                   {!windowResult?.result && (
//                     <div
//                       className="p-3 mt-2"
//                       style={{
//                         background: R.warnBg,
//                         border: `1px solid ${R.warnBorder}`,
//                         borderRadius: 12,
//                       }}
//                     >
//                       <div className="small" style={{ color: R.muted }}>
//                         Window placement is not as per Vastu principles for this
//                         direction. Consider relocating or adding a remedy such
//                         as a Vastu pyramid near the affected window.
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </VastuCard>
//           )}

//           {/* ================= LEVELING ================= */}
//           {tab === "leveling" && (
//             <VastuCard>
//               <div className="d-flex flex-wrap gap-4">
//                 <SectionImage
//                   src="/images/leveling.png"
//                   alt="Leveling"
//                   size={150}
//                 />
//                 <div className="flex-grow-1">
//                   <ResponsiveTable
//                     columns={[
//                       { title: "Direction", dataIndex: "name", key: "name" },
//                       {
//                         title: "Status",
//                         dataIndex: "result",
//                         key: "result",
//                         render: (v) => <StatusPill ok={v} />,
//                       },
//                     ]}
//                     dataSource={levelRows}
//                   />
//                   <div className="d-flex justify-content-between align-items-center mt-2 small">
//                     <span style={{ color: R.muted }}>Overall Leveling</span>
//                     <StatusPill ok={!!level?.result} />
//                   </div>
//                 </div>
//               </div>
//             </VastuCard>
//           )}

//           {/* ================= OTHER FACTORS ================= */}
//           {tab === "misc" && (
//             <VastuCard>
//               <div className="d-flex flex-wrap gap-4">
//                 <SectionImage
//                   src="/images/misc.png"
//                   alt="Other Factors"
//                   size={150}
//                 />
//                 <div className="flex-grow-1">
//                   <ResponsiveTable
//                     columns={[
//                       { title: "Item", dataIndex: "name", key: "name" },
//                       {
//                         title: "Result",
//                         dataIndex: "result",
//                         key: "result",
//                         render: (v) => <StatusPill ok={v} />,
//                       },
//                     ]}
//                     dataSource={miscData}
//                     emptyText="No miscellaneous items"
//                   />
//                 </div>
//               </div>
//             </VastuCard>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* =============== SCREEN — Feedback ================================== */
// function StepFeedback({ onDone }) {
//   const [rating, setRating] = useState(0);
//   const [feedback, setFeedback] = useState("");
//   const [submitted, setSubmitted] = useState(false);

//   if (submitted) {
//     return (
//       <div className="mx-auto px-3 py-5 text-center" style={{ maxWidth: 460 }}>
//         <div className="fs-1 mb-3">🙏</div>
//         <h2
//           style={{ ...display, fontWeight: 700, color: C.maroon }}
//           className="fs-2 mb-2"
//         >
//           Dhanyavaad!
//         </h2>
//         <p className="small mb-4" style={{ color: C.taupe }}>
//           Thank you for your valuable feedback
//         </p>
//         <PrimaryBtn onClick={onDone} variant="gold">
//           Back to Home
//         </PrimaryBtn>
//       </div>
//     );
//   }

//   return (
//     <div className="mx-auto px-3 py-4" style={{ maxWidth: 460 }}>
//       <VastuCard style={{ textAlign: "center" }}>
//         <div className="fs-2 mb-2">⭐</div>
//         <GoldHeading sub="Your feedback helps us improve our Vastu ">
//           Rate Your Experience
//         </GoldHeading>
//         <div className="d-flex justify-content-center mb-4">
//           <Rate
//             value={rating}
//             onChange={setRating}
//             style={{ fontSize: 36, color: C.gold }}
//           />
//         </div>
//         <div className="text-start mb-4">
//           <label
//             style={{
//               fontSize: 12,
//               fontWeight: 700,
//               color: C.maroon,
//               textTransform: "uppercase",
//               letterSpacing: "0.04em",
//               display: "block",
//               marginBottom: 4,
//             }}
//           >
//             Your Feedback
//           </label>
//           <textarea
//             value={feedback}
//             onChange={(e) => setFeedback(e.target.value)}
//             rows={4}
//             placeholder="Share your experience with our Vastu analysis…"
//             className="w-100"
//             style={{
//               resize: "none",
//               background: C.cream,
//               border: `1px solid ${C.border}`,
//               borderRadius: 10,
//               padding: "0.6rem 0.9rem",
//               fontSize: "0.9rem",
//             }}
//           />
//         </div>
//         <PrimaryBtn
//           onClick={() => setSubmitted(true)}
//           disabled={!rating}
//           fullWidth
//           variant="gold"
//         >
//           Submit Feedback
//         </PrimaryBtn>
//       </VastuCard>
//     </div>
//   );
// }

// /* =============== ROOT — HomeVastuFlow =============================== */
// export default function HomeVastuFlow({ onExit }) {
//   const [step, setStep] = useState("details"); // 'lagna' | 'details' | 'upload' | ...
//   const [details, setDetails] = useState({});
//   const [ocrResult, setOcrResult] = useState(null);
//   const [houseType, setHouseType] = useState(null);
//   const [detectedType, setDetectedType] = useState(null);
//   const [lagnaReturn, setLagnaReturn] = useState("details");
//   const [prefillLagna, setPrefillLagna] = useState("");
//   const [pricing, setPricing] = useState({ options: [] });

//   const [reportData, setReportData] = useState(null);
//   const [reportError, setReportError] = useState("");
//   const [generatingReport, setGeneratingReport] = useState(false);

//   const handleGenerateReport = async (payload) => {
//     const token = window.sessionStorage.getItem("token");
//     setGeneratingReport(true);
//     setReportError("");
//     try {
//       const res = await vasthuUrl.post(`/ocr/generateReport`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setReportData(res.data?.body);
//       go("generating"); // real data vandhadhum cosmetic animation kaatuvom
//     } catch (err) {
//       console.error("Generate report error:", err);
//       setReportError(
//         err?.response?.data?.detail ||
//         err?.response?.data?.message ||
//         "Failed to generate report. Please try again.",
//       );
//     } finally {
//       setGeneratingReport(false);
//     }
//   };

//   const go = (s) => setStep(s);
//   // const handleLagnaOpen = () => {
//   //   setLagnaReturn("details");
//   //   go("lagna");
//   // };
//   // const handleLagnaDone = (lagna) => {
//   //   setPrefillLagna(lagna);
//   //   go(lagnaReturn);
//   // };

//   const handleLagnaOpen = (currentDetails) => {
//     // Save current Owner & Home Details
//     setDetails(currentDetails);

//     setLagnaReturn("details");
//     go("lagna");
//   };

//   const handleLagnaDone = (lagna) => {
//     // Save selected/calculated Lagna
//     const matched = LAGNA_OPTIONS.find((o) =>
//       o.label.toLowerCase().includes(String(lagna).toLowerCase()),
//     );
//     setPrefillLagna(matched ? matched.value : lagna);

//     // Return to Owner & Home Details
//     go("details");
//   };

//   useEffect(() => {
//     const token = window.sessionStorage.getItem("token");
//     const fetchPricing = async () => {
//       try {
//         const res = await vasthuUrl.get(`/api/vastu-pricing/type/HOUSE`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         const rows = Array.isArray(res.data) ? res.data : res.data?.data || [];

//         const options = rows
//           .filter((r) => r.isActive)
//           .map((r) => ({
//             id: r.id, // needed as plan reference for payment API
//             key: r.subType, // e.g. "SINGLE_FLOOR", "TWO_FLOOR", "G3_ABOVE"
//             label: r.label,
//             price: r.minPrice,
//             maxPrice: r.maxPrice,
//             scope: r.scope,
//             isCustomQuote: r.priceUnit === "ON_REQUEST", // no fixed price → ask-for-quote flow
//           }));

//         setPricing({ options });
//       } catch (err) {
//         console.error("Pricing fetch error:", err);
//       }
//     };
//     fetchPricing();
//   }, []);

//   return (
//     <div style={{ background: C.cream, minHeight: "100vh" }}>
//       {step === "lagna" && (
//         <StepLagna onBack={() => go(lagnaReturn)} onDone={handleLagnaDone} />
//       )}

//       {step === "details" && (
//         // <StepDetails
//         //   onNext={(data) => {
//         //     setDetails(data);
//         //     go("upload");
//         //   }}
//         //   onLagna={handleLagnaOpen}
//         //   prefillLagna={prefillLagna}
//         // />
//         <StepDetails
//           onNext={(data) => {
//             setDetails(data);
//             go("upload");
//           }}
//           onLagna={handleLagnaOpen}
//           prefillLagna={prefillLagna}
//           initialDetails={details}
//         />
//       )}

//       {step === "upload" && (
//         <StepUpload
//           // onNext={(ocrData, ht) => {
//           //   setOcrResult(ocrData?.data);
//           //   setHouseType(ht);
//           //   const floorCount =
//           //     ocrData?.data?.elementDetails?.floorDetails?.length;
//           //   const detectedOption = pricing.options.find(
//           //     (o) => getFloorCountFromLabel(o.label) === floorCount,
//           //   );
//           //   setDetectedType(detectedOption ? detectedOption.key : ht);
//           //   go("scanning");
//           // }}
//           onNext={(ocrData, ht) => {
//             const merged = {
//               ...ocrData?.data,
//               houseDetails: {
//                 ...ocrData?.data?.houseDetails,
//                 building_front_width:
//                   Number(details?.hFacingWidth) ||
//                   ocrData?.data?.houseDetails?.building_front_width,
//               },
//             };

//             setOcrResult(merged);
//             setHouseType(ht);

//             const floorCount = merged?.elementDetails?.floorDetails?.length;
//             const detectedOption = pricing.options.find(
//               (o) => getFloorCountFromLabel(o.label) === floorCount,
//             );
//             setDetectedType(detectedOption ? detectedOption.key : ht);
//             go("scanning");
//           }}
//           onBack={() => go("details")}
//           pricing={pricing}
//           details={details}
//         />
//       )}

//       {step === "scanning" && <StepScanning onDone={() => go("payment")} />}

//       {step === "payment" && (
//         <StepPayment
//           houseType={houseType || detectedType}
//           ownerName={details.ownerName || ""}
//           onPay={() => go("post-payment")}
//           pricing={pricing}
//         />
//       )}

//       {step === "post-payment" && (
//         <StepPostPayment
//           onContinue={() => handleGenerateReport(ocrResult)}
//           onValidate={() => go("validate-data")}
//           generating={generatingReport}
//           error={reportError}
//         />
//       )}

//       {step === "validate-data" && (
//         <StepValidateData
//           ocrData={ocrResult}
//           doorPosition={details?.doorPosition}
//           onGenerate={handleGenerateReport}
//           generating={generatingReport}
//           error={reportError}
//         />
//       )}

//       {step === "generating" && <StepGenerating onDone={() => go("report")} />}

//       {step === "report" && (
//         <StepReport
//           ownerName={details.ownerName || "Your"}
//           reportData={reportData}
//           buildingArea={ocrResult?.houseDetails?.building_area}
//           perimeter={ocrResult?.houseDetails?.perimeter}
//           onReview={() => go("feedback")}
//         />
//       )}

//       {/* {step === "report" && (
//         <StepReport
//           ownerName={details.ownerName || "Your"}
//           reportData={reportData}
//           onReview={() => go("feedback")}
//         />
//       )} */}

//       {step === "feedback" && (
//         <StepFeedback onDone={() => (onExit ? onExit() : go("details"))} />
//       )}
//     </div>
//   );
// }



import { CheckCircleFilled } from "@ant-design/icons";
import { Progress, Rate, Spin, Table } from "antd";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { vasthuUrl } from "../component/Api";
import BillDeskPay from "../component/BillDeskPay";

/* ═══════════════════════ CONSTANTS ═══════════════════════ */

// Used by StepLagna (location search + lagna calculation).
// Move to vasthuUrl once its baseURL points to this server in every env.
const LAGNA_API_BASE = "https://vasthuparam.com/vasthuServices";

const DIRECTION_OPTIONS = [
  { value: "north", label: "North" },
  { value: "south", label: "South" },
  { value: "east", label: "East" },
  { value: "west", label: "West" },
  { value: "northeast", label: "North-East (Ishan)" },
  { value: "northwest", label: "North-West (Vayavya)" },
  { value: "southeast", label: "South-East (Agneya)" },
  { value: "southwest", label: "South-West (Nairutya)" },
];

const LAGNA_OPTIONS = [
  { value: "mesha", label: "Mesha (Aries)" },
  { value: "vrishabha", label: "Vrishabha (Taurus)" },
  { value: "mithuna", label: "Mithuna (Gemini)" },
  { value: "karka", label: "Karka (Cancer)" },
  { value: "simha", label: "Simha (Leo)" },
  { value: "kanya", label: "Kanya (Virgo)" },
  { value: "tula", label: "Tula (Libra)" },
  { value: "vrishchika", label: "Vrishchika (Scorpio)" },
  { value: "dhanu", label: "Dhanu (Sagittarius)" },
  { value: "makara", label: "Makara (Capricorn)" },
  { value: "kumbha", label: "Kumbha (Aquarius)" },
  { value: "meena", label: "Meena (Pisces)" },
];

const LEVEL_OPTIONS = [
  { value: "low", label: "USR.VSH.LVLTAB.DD.ITM.LW" },
  { value: "high", label: "USR.VSH.LVLTAB.DD.ITM.HG" },
];

const ALLOWED_FILE_TYPES = ["image/png", "image/jpeg", "application/pdf"];
const MAX_FLOOR_SLOTS = 5;
const NAME_REGEX = /^[a-zA-Z\s.'-]*$/;
const POSITIVE_NUMBER_REGEX = /^\d*\.?\d*$/;

const STEP_META = [
  { label: "TXT.DETS.LO", icon: "👤" },
  { label: "HOM.VAS.DET.UPL", icon: "🏢" },
  { label: "HOM.VAS.DET.SCN", icon: "🔍" },
  { label: "USR.HOM.HD.PAY", icon: "💳" },
  { label: "USR.BD.HMTAB.TBL.CLM.RP", icon: "📊" },
];

const SCAN_PHASES = [
  "Detecting floor count…",
  "Extracting measurements…",
  "Identifying rooms…",
  "Analyzing directions…",
  "Checking Vastu elements…",
  "Finalizing report data…",
];

const GENERATE_PHASES = [
  "Mapping directional energies…",
  "Calculating Vastu score…",
  "Identifying defects…",
  "Generating corrections…",
  "Composing report…",
];

/* ── style tokens ── */
const C = {
  maroon: "#7B1E1E",
  gold: "#C8860A",
  cream: "#FDF8F0",
  creamCard: "#FFF8EE",
  sand: "#F5EFE6",
  border: "#E8D8C4",
  taupe: "#8B6A4F",
  ink: "#2D1A0E",
  placeholder: "#C4A882",
};

const R = {
  header: "linear-gradient(135deg,#F7B733 0%,#F2A71B 100%)",
  good: "#1F9254",
  goodBg: "#E9F7EF",
  bad: "#D64545",
  badBg: "#FDEBEB",
  warnBg: "#FFF6E3",
  warnBorder: "#F3D08A",
  muted: "#8B7358",
  ink: "#2D1A0E",
};

const display = { fontFamily: "'Cormorant Garamond', 'Noto Serif', serif" };

const labelStyle = {
  fontSize: 12,
  fontWeight: 700,
  color: C.maroon,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const inputStyle = {
  background: C.cream,
  border: `1px solid ${C.border}`,
  borderRadius: 10,
  padding: "0.6rem 0.9rem",
  fontSize: "0.9rem",
};

/* ═══════════════════════ HELPERS ═══════════════════════ */

function validateName(value) {
  if (value && !NAME_REGEX.test(value)) {
    return "Numbers/special characters not allowed";
  }
  return "";
}

function validateNumber(value, max) {
  if (!value) return "";
  const n = parseFloat(value);
  if (!(n > 0)) return "Value must be greater than 0";
  if (max && n > max) return `Maximum allowed is ${max} ft`;
  return "";
}

const isPositive = (v, max) => {
  const n = parseFloat(v);
  return n > 0 && (!max || n <= max);
};

// "Not Good" contains the word "good", so a plain /good/ test is wrong.
function isGood(value) {
  const s = String(value ?? "");
  return /good|excellent/i.test(s) && !/not\s*good/i.test(s);
}

function getFloorCountFromLabel(label = "") {
  const g = label.match(/G\+(\d+)/i);
  if (g) return parseInt(g[1], 10) + 1;
  const f = label.match(/(\d+)\s*floors?/i);
  if (f) return parseInt(f[1], 10);
  return 1;
}

function deriveLevelValues(details) {
  const bit = (v) => (v === "high" ? 1 : 0);
  return {
    southLevel: bit(details?.southLevel),
    northLevel: bit(details?.northLevel),
    southWestLevel: bit(details?.southWestLevel),
    northEastLevel: bit(details?.northEastLevel),
    westLevel: bit(details?.westLevel),
    eastLevel: bit(details?.eastLevel),
  };
}

function formatFloorName(name = "") {
  return name
    .split("-")
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");
}

// Drives the cosmetic progress screens; cleans up its timers on unmount.
function usePhases(total, intervalMs, onDone) {
  const [phase, setPhase] = useState(0);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    let i = 0;
    let finish;
    const timer = setInterval(() => {
      i += 1;
      setPhase(i);
      if (i >= total) {
        clearInterval(timer);
        finish = setTimeout(() => doneRef.current(), 800);
      }
    }, intervalMs);
    return () => {
      clearInterval(timer);
      clearTimeout(finish);
    };
  }, [total, intervalMs]);

  return phase;
}

/* ═══════════════════════ SHARED UI ═══════════════════════ */

function OmSymbol({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
      <text
        x="50%"
        y="56%"
        textAnchor="middle"
        fontSize={size * 0.8}
        fontFamily="Noto Serif"
        fill={C.gold}
        dominantBaseline="middle"
      >
        ॐ
      </text>
    </svg>
  );
}

// Put the PNGs in /public/images/
function SectionImage({ src, alt, size = 150 }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 14,
        overflow: "hidden",
        flexShrink: 0,
        background: "#F6EEE2",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
      />
    </div>
  );
}

function VastuCard({ children, style = {} }) {
  return (
    <div
      style={{
        background: "#fff",
        border: `1px solid ${C.border}`,
        borderRadius: 18,
        boxShadow: "0 8px 24px rgba(123,30,30,0.06)",
        padding: "1.5rem",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

function GoldHeading({ children, sub }) {
  return (
    <div className="text-center mb-4">
      <h2 style={{ ...display, fontWeight: 700, color: C.maroon, fontSize: "1.9rem" }}>
        {children}
      </h2>
      {sub && (
        <p className="small mb-0" style={{ color: C.taupe }}>
          {sub}
        </p>
      )}
    </div>
  );
}

function BackButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="btn btn-link text-decoration-none small mb-3 px-0"
      style={{ color: C.taupe }}
    >
      ← Back
    </button>
  );
}

function ErrorAlert({ children, className = "" }) {
  if (!children) return null;
  return (
    <Alert
      className={className}
      style={{ background: "#FDEDED", color: "#B23A3A", fontSize: "0.85rem" }}
    >
      {children}
    </Alert>
  );
}

function FieldInput({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  required = false,
  helpText = "",
  error = "",
}) {
  const { t } = useTranslation();

  return (
    <Form.Group className="mb-3">
      <Form.Label style={labelStyle}>
        {t(label)} {required && <span style={{ color: C.gold }}>*</span>}
      </Form.Label>
      <Form.Control
        type={type}
        value={value}
        placeholder={t(placeholder)}
        isInvalid={!!error}
        onChange={(e) => {
          let val = e.target.value;
          // HH:mm → HH:mm:ss
          if (type === "time" && val && val.length === 5) val = `${val}:00`;
          onChange(val);
        }}
        style={{ ...inputStyle, border: `1px solid ${error ? R.bad : C.border}` }}
      />
      {error ? (
        <div style={{ color: R.bad, fontSize: 11.5, marginTop: 4 }}>{t(error)}</div>
      ) : (
        helpText && (
          <Form.Text style={{ color: C.taupe, fontSize: 11.5 }}>{t(helpText)}</Form.Text>
        )
      )}
    </Form.Group>
  );
}

function FieldSelect({ label, value, onChange, options, required = false, select, helpText = "" }) {
  const { t } = useTranslation();
  return (
    <Form.Group className="mb-3">
      <Form.Label style={labelStyle}>
        {t(label)} {required && <span style={{ color: C.gold }}>*</span>}
      </Form.Label>
      <Form.Select value={value} onChange={(e) => onChange(e.target.value)} style={inputStyle}>
        <option value="">{t(select)}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {t(o.label)}
          </option>
        ))}
      </Form.Select>
      {helpText && (
        <Form.Text style={{ color: C.taupe, fontSize: 11.5 }}>{t(helpText)}</Form.Text>
      )}
    </Form.Group>
  );
}

function PrimaryBtn({ children, onClick, disabled = false, fullWidth = false, variant = "primary" }) {
  const styles = {
    primary: { background: C.maroon, borderColor: C.maroon, color: "#fff" },
    gold: { background: C.gold, borderColor: C.gold, color: "#fff" },
    outline: { background: "transparent", border: `2px solid ${C.maroon}`, color: C.maroon },
  }[variant];
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`btn ${fullWidth ? "w-100" : ""}`}
      style={{
        ...styles,
        fontWeight: 600,
        borderRadius: 12,
        padding: "0.6rem 1.3rem",
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {children}
    </button>
  );
}

function Spinning({ children }) {
  return (
    <span className="d-inline-flex align-items-center gap-2">
      <Spin size="small" /> {children}
    </span>
  );
}

/* ═══════════════════════ STEP BAR ═══════════════════════ */

function StepBar({ current }) {
  const { t } = useTranslation();
  const currentStep = STEP_META[current - 1];

  return (
    <div className="mx-auto mb-4" style={{ width: "100%", maxWidth: 640 }}>
      {/* desktop */}
      <div className="stepbar-desktop">
        <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
          {STEP_META.map((s, i) => {
            const n = i + 1;
            const done = n < current;
            const active = n === current;
            return (
              <div key={s.label} style={{ flex: 1, display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: 34,
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 12,
                      fontWeight: 700,
                      background: done || active ? C.gold : "#E5E5E5",
                      color: done || active ? "#fff" : "#999",
                    }}
                  >
                    {done ? "✓" : n}
                  </div>
                  <span
                    style={{
                      marginTop: 6,
                      fontSize: 10,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      color: active ? C.maroon : C.taupe,
                      fontWeight: active ? 700 : 400,
                    }}
                  >
                    {t(s.label)}
                  </span>
                </div>
                {i < STEP_META.length - 1 && (
                  <div
                    style={{
                      flex: 1,
                      height: 2,
                      marginTop: -20,
                      background: done ? C.gold : "#E5E5E5",
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* mobile */}
      <div className="stepbar-mobile">
        <div
          style={{
            background: C.creamCard,
            border: `1px solid ${C.border}`,
            borderRadius: 14,
            padding: "12px 14px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: C.taupe,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              marginBottom: 8,
            }}
          >
            Step {current} of {STEP_META.length}
          </div>
          <div
            style={{
              width: 42,
              height: 42,
              margin: "0 auto 7px",
              borderRadius: "50%",
              background: C.gold,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
            }}
          >
            {currentStep.icon}
          </div>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.maroon }}>
            {t(currentStep.label)}
          </div>
          <div style={{ display: "flex", gap: 5, marginTop: 10, justifyContent: "center" }}>
            {STEP_META.map((_, i) => (
              <div
                key={i}
                style={{
                  width: i + 1 === current ? 22 : 6,
                  height: 5,
                  borderRadius: 10,
                  background: i + 1 <= current ? C.gold : "#E5E5E5",
                  transition: "all 0.2s ease",
                }}
              />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .stepbar-mobile { display: none; }
        .stepbar-desktop { display: block; }
        @media (max-width: 576px) {
          .stepbar-desktop { display: none; }
          .stepbar-mobile { display: block; }
        }
      `}</style>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Know My Lagna ═══════════════════════ */

function StepLagna({ onBack, onDone }) {
  const { t } = useTranslation();
  const token = window.sessionStorage.getItem("token");

  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [tob, setTob] = useState("");
  const [pob, setPob] = useState(""); // only set when a suggestion is picked
  const [calculating, setCalculating] = useState(false);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const [searchLocation, setSearchLocation] = useState("");
  const [options, setOptions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const skipNextFetch = useRef(false);

  useEffect(() => {
    // selecting a suggestion changes searchLocation — don't re-search for it
    if (skipNextFetch.current) {
      skipNextFetch.current = false;
      return;
    }
    if (!searchLocation.trim() || !token) {
      setOptions([]);
      setShowSuggestions(false);
      return;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const res = await axios.get(`${LAGNA_API_BASE}/api/vasthu/searchLocation`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { keyword: searchLocation, lang: "en" },
        });
        if (cancelled) return;
        setOptions(Array.isArray(res.data) ? res.data : []);
        setShowSuggestions(true);
      } catch (err) {
        console.error("Location search error:", err);
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [searchLocation, token]);

  const handleSelectSuggestion = (place) => {
    skipNextFetch.current = true;
    setSearchLocation(place);
    setPob(place);
    setShowSuggestions(false);
  };

  const clearLocation = () => {
    setSearchLocation("");
    setPob("");
    setOptions([]);
    setShowSuggestions(false);
  };

  const handleSubmit = async () => {
    if (calculating || !pob || !dob || !name || !tob) return;
    setCalculating(true);
    setError("");
    try {
      const res = await axios.post(
        `${LAGNA_API_BASE}/api/astro/generate`,
        { userName: name, userBirthstate: pob, birthDate: dob, birthTime: tob, lang: "en" },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (!res?.data?.lagna) throw new Error("No lagna in response");
      setResult(res.data.lagna);
    } catch (err) {
      console.error("Lagna calculation error:", err);
      setError("Could not calculate your Lagna. Please check the details and try again.");
    } finally {
      setCalculating(false);
    }
  };

  return (
    <div className="mx-auto px-3 py-4" style={{ maxWidth: 520 }}>
      <BackButton onClick={onBack} />
      <VastuCard>
        <div className="text-center mb-4">
          <div className="fs-2 mb-2">🔭</div>
          <GoldHeading sub="Enter your birth details to calculate your Lagna (Ascendant)">
            {t("HOM.VAS.IMG.DET.KML")}
          </GoldHeading>
        </div>

        {!result ? (
          <div>
            <FieldInput
              label="Full Name"
              value={name}
              onChange={setName}
              placeholder="e.g. Ramesh Kumar"
              required
            />
            <FieldInput label="Date of Birth" value={dob} onChange={setDob} type="date" required />
            <FieldInput label="Time of Birth" value={tob} onChange={setTob} type="time" required />

            <Form.Group className="mb-3 position-relative">
              <Form.Label style={labelStyle}>
                Place of Birth <span style={{ color: C.gold }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={searchLocation}
                placeholder="e.g. Chennai, Tamil Nadu"
                autoComplete="off"
                onChange={(e) => {
                  setSearchLocation(e.target.value);
                  setPob(""); // must pick from the list again
                }}
                style={inputStyle}
              />
              {searchLocation && (
                <span
                  role="button"
                  aria-label="Clear location"
                  onClick={clearLocation}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "68%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "1.2rem",
                    color: "#aaa",
                  }}
                >
                  &times;
                </span>
              )}
              {searchLocation && !pob && !showSuggestions && (
                <Form.Text style={{ color: C.taupe, fontSize: 11.5 }}>
                  Select your place from the suggestions.
                </Form.Text>
              )}

              {showSuggestions && options.length > 0 && (
                <ul
                  style={{
                    listStyleType: "none",
                    padding: 0,
                    marginTop: 4,
                    border: `1px solid ${C.border}`,
                    maxHeight: 150,
                    overflowY: "auto",
                    position: "absolute",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 999,
                    borderRadius: 8,
                  }}
                >
                  {options.map((place) => (
                    <li
                      key={place}
                      onClick={() => handleSelectSuggestion(place)}
                      style={{
                        padding: 8,
                        cursor: "pointer",
                        borderBottom: `1px solid ${C.border}`,
                        fontSize: "0.85rem",
                      }}
                    >
                      {place}
                    </li>
                  ))}
                </ul>
              )}
            </Form.Group>

            <ErrorAlert>{error}</ErrorAlert>

            <PrimaryBtn
              onClick={handleSubmit}
              disabled={!name || !dob || !tob || !pob || calculating}
              fullWidth
              variant="gold"
            >
              {calculating ? <Spinning>Calculating…</Spinning> : "Calculate My Lagna"}
            </PrimaryBtn>
          </div>
        ) : (
          <div className="text-center">
            <div
              className="rounded-circle mx-auto d-flex align-items-center justify-content-center fs-2 mb-3"
              style={{ width: 80, height: 80, background: "#FFF3DC", border: `4px solid ${C.gold}` }}
            >
              ♈
            </div>
            <p
              className="text-uppercase small mb-1"
              style={{ color: C.taupe, letterSpacing: "0.1em", fontSize: 11 }}
            >
              Your Lagna is
            </p>
            <h3
              style={{ ...display, fontWeight: 700, color: C.maroon, fontSize: "1.6rem" }}
              className="mb-3"
            >
              {result}
            </h3>
            <div
              className="rounded-3 p-3 small mb-4"
              style={{ background: C.creamCard, color: C.taupe, border: `1px solid ${C.border}` }}
            >
              This Lagna is associated with leadership, vitality, and dynamic energy in your
              home's Vastu alignment.
            </div>
            <PrimaryBtn onClick={() => onDone(result)} fullWidth variant="gold">
              Use This Lagna →
            </PrimaryBtn>
          </div>
        )}
      </VastuCard>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Owner & Home Details ═══════════════════════ */

function StepDetails({ onNext, onLagna, prefillLagna, initialDetails }) {
  const { t } = useTranslation();
  const d = initialDetails || {};

  const [form, setForm] = useState({
    ownerName: d.ownerName || "",
    lagna: prefillLagna || d.lagna || "",
    doorWidth: d.doorWidth || "",
    doorPosition: d.doorPosition || "",
    perimeter: d.perimeter || "",
    doorGap: d.doorGap || "",
    hFacingWidth: d.hFacingWidth || "",
    southLevel: d.southLevel || "",
    northLevel: d.northLevel || "",
    southWestLevel: d.southWestLevel || "",
    northEastLevel: d.northEastLevel || "",
    westLevel: d.westLevel || "",
    eastLevel: d.eastLevel || "",
  });
  const [errors, setErrors] = useState({});

  const set = (key) => (v) => setForm((f) => ({ ...f, [key]: v }));

  const setErr = (key, msg) => setErrors((e) => ({ ...e, [key]: msg }));

  const setName = (key) => (v) => {
    if (v && !NAME_REGEX.test(v)) {
      setErr(key, validateName(v));
      return;
    }
    setErr(key, "");
    set(key)(v);
  };

  const setNumber = (key, max) => (v) => {
    if (v && !POSITIVE_NUMBER_REGEX.test(v)) return; // ignore invalid keystrokes
    setErr(key, validateNumber(v, max));
    set(key)(v);
  };

  // Low/high selections are mirrored: picking one side sets the opposite side
  const setPaired = (key, pairKey) => (v) =>
    setForm((f) => ({
      ...f,
      [key]: v,
      [pairKey]: v === "low" ? "high" : v === "high" ? "low" : f[pairKey],
    }));

  const valid =
    form.ownerName &&
    form.lagna &&
    form.doorPosition &&
    isPositive(form.doorWidth) &&
    isPositive(form.doorGap) &&
    isPositive(form.perimeter) &&
    isPositive(form.hFacingWidth, 120) &&
    form.southLevel &&
    form.northLevel &&
    form.southWestLevel &&
    form.northEastLevel &&
    form.westLevel &&
    form.eastLevel &&
    !Object.values(errors).some(Boolean);

  const levelPair = (a, b, labels) => (
    <div className="d-flex gap-2">
      {[a, b].map((key, i) => (
        <div className="flex-grow-1" key={key}>
          <FieldSelect
            label={labels[i].label}
            value={form[key]}
            onChange={setPaired(key, i === 0 ? b : a)}
            required
            options={LEVEL_OPTIONS}
            select={labels[i].select}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className="mx-auto px-3 py-4" style={{ maxWidth: 560 }}>
      <StepBar current={1} />
      <VastuCard>
        <GoldHeading sub="Please provide your home details for accurate Vastu analysis">
          Owner &amp; Home Details
        </GoldHeading>

        <FieldInput
          label="USR.VSH.HFTAB.LBL.HO"
          value={form.ownerName}
          onChange={setName("ownerName")}
          placeholder="USR.VSH.HFTAB.HO.PH"
          required
          error={errors.ownerName}
        />

        <Form.Group className="mb-3">
          <Form.Label style={labelStyle}>
            {t("USR.VSH.HFTAB.LG.PH")} <span style={{ color: C.gold }}>*</span>
          </Form.Label>
          <div className="d-flex gap-2">
            <Form.Select
              className="flex-grow-1"
              value={form.lagna}
              onChange={(e) => set("lagna")(e.target.value)}
              style={{ background: C.cream, border: `1px solid ${C.border}`, borderRadius: 10 }}
            >
              <option value="">{t("USR.VSH.HFTAB.LG.PH")}…</option>
              {LAGNA_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </Form.Select>
            <button
              onClick={() => onLagna(form)}
              className="btn small text-nowrap fw-semibold px-3"
              style={{
                background: "#FFF3DC",
                color: C.gold,
                border: `1px solid ${C.gold}`,
                fontSize: 12,
              }}
            >
              {t("HOM.VAS.IMG.DET.KML")}
            </button>
          </div>
        </Form.Group>

        {levelPair("southLevel", "northLevel", [
          { label: "USR.VSH.LVLTAB.SXN.LB.ST", select: "USR.VSH.LVLTAB.SXN.ST.DD.PH" },
          { label: "USR.VSH.LVLTAB.SXN.LB.NR", select: "USR.VSH.LVLTAB.SXN.NR.DD.PH" },
        ])}
        {levelPair("southWestLevel", "northEastLevel", [
          { label: "USR.VSH.LVLTAB.SWXNE.LB.ST", select: "USR.VSH.LVLTAB.SWXNE.ST.DD.PH" },
          { label: "USR.VSH.LVLTAB.SWXNE.LB.NR", select: "USR.VSH.LVLTAB.SWXNE.NR.DD.PH" },
        ])}
        {levelPair("westLevel", "eastLevel", [
          { label: "USR.VSH.LVLTAB.WXE.LB.ST", select: "USR.VSH.LVLTAB.WXE.ST.DD.PH" },
          { label: "USR.VSH.LVLTAB.WXE.LB.NR", select: "USR.VSH.LVLTAB.WXE.NR.DD.PH" },
        ])}

        <FieldInput
          label="USR.VSH.HFTAB.LBL.MDW"
          value={form.doorWidth}
          onChange={setNumber("doorWidth")}
          placeholder="e.g. 3.5"
          required
          error={errors.doorWidth}
        />
        <FieldInput
          label="USR.VSH.HFTAB.LBL.MDD"
          value={form.doorGap}
          onChange={setNumber("doorGap")}
          placeholder="e.g. 11"
          required
          helpText="USR.VSH.HFTAB.MDD.HTXT"
          error={errors.doorGap}
        />
        <FieldSelect
          label="USR.VSH.HFTAB.LBL.HF"
          value={form.doorPosition}
          onChange={set("doorPosition")}
          required
          options={DIRECTION_OPTIONS}
          select="USR.VSH.HFTAB.HF.PH"
          helpText="USR.VSH.HFTAB.HF.HTXT"
        />
        <FieldInput
          label="USR.VFPR.TBL.CLMN.PR"
          value={form.perimeter}
          onChange={setNumber("perimeter")}
          placeholder="e.g. 120"
          required
          error={errors.perimeter}
        />
        <FieldInput
          label="USR.VSH.HFTAB.LBL.FFW"
          value={form.hFacingWidth}
          onChange={setNumber("hFacingWidth", 120)}
          placeholder="e.g. 40"
          required
          error={errors.hFacingWidth}
        />

        <div className="mt-3">
          <PrimaryBtn onClick={() => onNext(form)} disabled={!valid} fullWidth variant="gold">
            Proceed to Upload →
          </PrimaryBtn>
        </div>
      </VastuCard>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Upload House Plan ═══════════════════════ */

function StepUpload({ onNext, onBack, pricing, details }) {
  const { options } = pricing;
  const token = window.sessionStorage.getItem("token");
  const userId = window.sessionStorage.getItem("userId");

  const [houseType, setHouseType] = useState(null);
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [agreed, setAgreed] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [detectedCount, setDetectedCount] = useState(null);

  const selectedOption = options.find((o) => o.key === houseType);
  const expectedCount = selectedOption
    ? Math.min(getFloorCountFromLabel(selectedOption.label), MAX_FLOOR_SLOTS)
    : 0;

  const detectedOption = options.find((o) => getFloorCountFromLabel(o.label) === detectedCount);

  // One ref per floor slot
  const inputRefs = useRef({});
  const setInputRef = (index) => (el) => {
    inputRefs.current[index] = el;
  };

  // Track object URLs so they can be revoked
  const urlsRef = useRef({});
  const revokeUrl = (index) => {
    if (urlsRef.current[index]) {
      URL.revokeObjectURL(urlsRef.current[index]);
      delete urlsRef.current[index];
    }
  };
  const revokeAll = () => Object.keys(urlsRef.current).forEach(revokeUrl);
  useEffect(() => revokeAll, []); // eslint-disable-line react-hooks/exhaustive-deps

  const resetFiles = () => {
    revokeAll();
    setFiles([]);
    setPreviews([]);
  };

  const handleFile = (f, index) => {
    if (!ALLOWED_FILE_TYPES.includes(f.type)) {
      setError("Please upload PNG, JPG or PDF only.");
      return;
    }
    setError("");
    revokeUrl(index);

    let previewUrl = null;
    if (f.type.startsWith("image/")) {
      previewUrl = URL.createObjectURL(f);
      urlsRef.current[index] = previewUrl;
    }

    setFiles((prev) => {
      const next = [...prev];
      next[index] = f;
      return next;
    });
    setPreviews((prev) => {
      const next = [...prev];
      next[index] = previewUrl;
      return next;
    });
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    const f = e.dataTransfer.files[0];
    if (f) handleFile(f, index);
  };

  const allFilesReady = Boolean(files[0]); // first floor is mandatory, rest optional

  const handleStartAnalysis = async () => {
    if (!allFilesReady || uploading) return;
    setUploading(true);
    setError("");
    setDetectedCount(null);

    try {
      const formData = new FormData();

      for (let i = 0; i < expectedCount; i++) {
        if (files[i]) formData.append(`file${i + 1}`, files[i]);
      }

      const fields = {
        expected_plan_count: expectedCount,
        ownerName: details?.ownerName,
        lagna: details?.lagna,
        doorWidth: details?.doorWidth,
        doorPosition: details?.doorPosition,
        perimeter: details?.perimeter,
        building_front_width: details?.hFacingWidth,
        doorGap: details?.doorGap,
        ...deriveLevelValues(details),
        userUUId: userId,
      };
      Object.entries(fields).forEach(([k, v]) => formData.append(k, v ?? ""));

      // Do not set Content-Type manually — the browser adds the multipart boundary.
      const response = await vasthuUrl.post(`/ocr/extract`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      onNext(response.data, houseType);
    } catch (err) {
      console.error("OCR Extract Error:", err);
      const rawMsg = String(
        err?.response?.data?.errors?.[0] ||
        err?.response?.data?.detail ||
        "Upload failed. Please try again.",
      );

      const detailMatch = rawMsg.match(/"detail"\s*:\s*"([^"]*(?:\\.[^"]*)*)"/);
      const cleanMsg = detailMatch ? detailMatch[1] : rawMsg;

      const countMatch = cleanMsg.match(/(?:detected|extracted)\s+(\d+)\s+plan/i);
      const detected = countMatch ? parseInt(countMatch[1], 10) : null;
      const hasMatchingOption =
        detected && options.some((o) => getFloorCountFromLabel(o.label) === detected);

      setDetectedCount(hasMatchingOption ? detected : null);
      setError(cleanMsg);
    } finally {
      setUploading(false);
    }
  };

  const renderDropZoneContent = (index) => {
    const file = files[index];

    if (!file) {
      return (
        <div>
          <div className="fs-1 mb-2">📐</div>
          <p className="small fw-semibold mb-1" style={{ color: C.maroon }}>
            Drop your house plan here
          </p>
          <p className="small mb-0" style={{ color: C.taupe }}>
            or click to browse · PNG, JPG, PDF
          </p>
        </div>
      );
    }

    return (
      <div>
        {previews[index] ? (
          <img
            src={previews[index]}
            alt={`House plan ${index + 1} preview`}
            className="mx-auto rounded-3 mb-2"
            style={{ maxHeight: 140, maxWidth: "100%", objectFit: "contain", display: "block" }}
          />
        ) : (
          <>
            <div className="fs-1 mb-1">📄</div>
            <p className="small fw-semibold mb-1" style={{ color: C.maroon }}>
              PDF uploaded
            </p>
          </>
        )}
        <p className="small mb-0 text-truncate" style={{ color: C.taupe }}>
          {file.name}
        </p>
        <p className="small mt-1 mb-0" style={{ color: C.gold }}>
          Click to change
        </p>
      </div>
    );
  };

  return (
    <div className="mx-auto px-3 py-4" style={{ maxWidth: 560 }}>
      <StepBar current={2} />
      <BackButton onClick={onBack} />
      <VastuCard>
        <GoldHeading sub="Select your house type to view pricing">Upload House Plan</GoldHeading>

        <Alert
          style={{
            background: C.creamCard,
            border: `1px solid ${C.border}`,
            color: C.taupe,
            fontSize: "0.9rem",
          }}
        >
          <span style={{ color: C.gold, fontWeight: 600 }}>ℹ️ Note:</span> The cost depends on the
          complexity and number of floors in your uploaded plan.
        </Alert>

        <div className="mb-3">
          <p style={labelStyle} className="mb-2">
            Select House Type <span style={{ color: C.gold }}>*</span>
          </p>
          <div className="d-flex flex-column gap-2">
            {options
              .filter((o) => !o.isCustomQuote)
              .map((o) => {
                const selected = houseType === o.key;
                return (
                  <button
                    key={o.key}
                    onClick={() => {
                      setHouseType(o.key);
                      setAgreed(false);
                      resetFiles();
                      setError("");
                      setDetectedCount(null);
                    }}
                    className="w-100 d-flex align-items-center justify-content-between px-3 py-2"
                    style={{
                      borderRadius: 12,
                      border: `2px solid ${selected ? C.gold : C.border}`,
                      background: selected ? C.creamCard : "#fff",
                    }}
                  >
                    <span className="fw-medium small" style={{ color: C.ink }}>
                      {o.label}
                    </span>
                    <span className="d-flex align-items-center gap-2">
                      <span className="fw-bold" style={{ color: C.gold }}>
                        ₹{(o.price ?? 0).toLocaleString()}
                      </span>
                      <span
                        className="rounded-circle d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 16,
                          height: 16,
                          border: `2px solid ${selected ? C.gold : C.border}`,
                          background: selected ? C.gold : "transparent",
                        }}
                      >
                        {selected && (
                          <span
                            className="rounded-circle bg-white"
                            style={{ width: 6, height: 6 }}
                          />
                        )}
                      </span>
                    </span>
                  </button>
                );
              })}
          </div>
        </div>

        {houseType && !agreed && (
          <Alert
            style={{
              background: "#FFF3DC",
              border: "1px solid rgba(200,134,10,.35)",
              color: C.taupe,
              fontSize: "0.9rem",
            }}
          >
            Proceeding will charge{" "}
            <span className="fw-bold" style={{ color: C.gold }}>
              ₹{(selectedOption?.price ?? 0).toLocaleString()}
            </span>{" "}
            for a {selectedOption?.label} Vastu analysis. Do you agree?
            <button
              onClick={() => setAgreed(true)}
              className="btn btn-sm ms-3 rounded-pill"
              style={{ background: C.gold, color: "#fff", fontSize: 11 }}
            >
              Yes, Proceed
            </button>
          </Alert>
        )}

        {agreed && (
          <div>
            <p style={labelStyle} className="mb-2">
              Upload {expectedCount > 1 ? "All Floor Plans" : "House Plan"}{" "}
              <span style={{ color: C.gold }}>*</span>
            </p>

            <div className="d-flex flex-column gap-3">
              {Array.from({ length: expectedCount }).map((_, index) => (
                <div key={index}>
                  {expectedCount > 1 && (
                    <p className="small fw-semibold mb-1" style={{ color: C.maroon }}>
                      Floor {index + 1} Plan
                      {index > 0 && index === expectedCount - 1 && (
                        <span style={{ color: C.taupe, fontWeight: 400 }}>
                          {" "}
                          (Optional — skip if an earlier sheet already covers it)
                        </span>
                      )}
                    </p>
                  )}
                  <div
                    onDrop={(e) => handleDrop(e, index)}
                    onDragOver={(e) => e.preventDefault()}
                    onClick={() => inputRefs.current[index]?.click()}
                    style={{
                      border: `2px dashed ${C.gold}`,
                      borderRadius: 16,
                      padding: "1.25rem",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      ref={setInputRef(index)}
                      type="file"
                      accept="image/png,image/jpeg,application/pdf"
                      className="d-none"
                      onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (f) handleFile(f, index);
                        e.target.value = ""; // allow re-selecting the same file
                      }}
                    />
                    {renderDropZoneContent(index)}
                  </div>
                </div>
              ))}
            </div>

            {error && (
              <Alert
                className="mt-3 mb-0"
                style={{ background: "#FDEDED", color: "#B23A3A", fontSize: "0.85rem" }}
              >
                {error}
                {detectedOption && detectedOption.key !== houseType && (
                  <div className="mt-2">
                    <button
                      onClick={() => {
                        setHouseType(detectedOption.key);
                        setError("");
                        setDetectedCount(null);
                      }}
                      className="btn btn-sm rounded-pill"
                      style={{ background: C.gold, color: "#fff", fontSize: 11 }}
                    >
                      Switch to {detectedOption.label} (₹
                      {(detectedOption.price ?? 0).toLocaleString()})
                    </button>
                  </div>
                )}
              </Alert>
            )}

            <div className="mt-3">
              <PrimaryBtn
                onClick={handleStartAnalysis}
                disabled={!allFilesReady || uploading}
                fullWidth
                variant="gold"
              >
                {uploading ? <Spinning>Analyzing…</Spinning> : "Start Analysis →"}
              </PrimaryBtn>
            </div>
          </div>
        )}
      </VastuCard>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Scanning ═══════════════════════ */

function StepScanning({ onDone }) {
  const phase = usePhases(SCAN_PHASES.length, 900, onDone);
  const progress = Math.round((phase / SCAN_PHASES.length) * 100);

  return (
    <div className="mx-auto px-3 py-5 text-center" style={{ maxWidth: 460 }}>
      <StepBar current={3} />
      <div className="mx-auto mb-4 position-relative" style={{ width: 160, height: 160 }}>
        <Progress
          type="circle"
          percent={progress}
          size={160}
          strokeColor={{ "0%": C.maroon, "100%": C.gold }}
          trailColor={C.border}
          format={() => <span style={{ fontSize: 0 }} />}
        />
        <div className="position-absolute top-50 start-50 translate-middle">
          <OmSymbol size={40} />
        </div>
      </div>
      <h2
        style={{ ...display, fontWeight: 700, color: C.maroon, fontSize: "1.7rem" }}
        className="mb-2"
      >
        Scanning…
      </h2>
      <p className="small mb-3" style={{ color: C.taupe, minHeight: 24 }}>
        {SCAN_PHASES[Math.min(phase, SCAN_PHASES.length - 1)]}
      </p>
      <p className="small" style={{ color: C.taupe }}>
        {progress}% complete
      </p>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Payment ═══════════════════════
   https → real BillDesk payment
   http  → simulated payment (test build only)
   NOTE: the backend must verify the payment before /ocr/generateReport.
═══════════════════════════════════════════════════════════════ */

function StepPayment({ houseType, ownerName, onPay, pricing }) {
  const selectedOption = pricing.options.find((o) => o.key === houseType);
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState("");
  const token = window.sessionStorage.getItem("token");
  const userId = window.sessionStorage.getItem("userId");
  const authHeaders = { headers: { Authorization: `Bearer ${token}` } };

  const isHttps = window.location.protocol === "https:";
  const total = selectedOption?.price ?? 0;

  const fail = (message, err) => {
    if (err) console.error(message, err?.response?.data || err?.message || err);
    setError(message);
    setPaying(false);
  };

  const handleFakePay = () => {
    console.warn("[TEST BUILD] Skipping real BillDesk payment — simulating success.");
    setTimeout(() => {
      setPaying(false);
      onPay();
    }, 1200);
  };

  const billDeskHandler = (txn) => {
    if (!txn?.txnResponse?.transaction_response) {
      fail("Invalid payment response. Please try again.", txn);
      return;
    }

    vasthuUrl
      .post(
        "/user/bdpaymentresponseuihomevasthu",
        { txn: txn.txnResponse.transaction_response },
        authHeaders,
      )
      .then((res) => {
        if (res.data?.transaction_error_type !== "success") {
          throw new Error(res.data?.transaction_error_desc || "BillDesk payment failed");
        }
        return vasthuUrl.post("/user/bdpaymentresponsehandlerhomevasthu", txn, authHeaders);
      })
      .then(() => {
        setPaying(false);
        onPay();
      })
      .catch((err) => fail("Payment could not be completed. Please try again.", err));
  };

  const handleRealPay = async () => {
    try {
      const res = await vasthuUrl.post(
        "/openapi/createhomevasthuorderapi",
        {
          userUuid: userId,
          pricingId: Number(selectedOption.id),
          price: Number(selectedOption.price),
          currency: "356",
        },
        { headers: { ...authHeaders.headers, "Content-Type": "application/json" } },
      );

      const data = res.data;
      if (!data) throw new Error("Empty response from payment API");
      if (data.status !== 200) throw new Error(`Order creation failed. Status: ${data.status}`);
      if (!data.bdOrderId) throw new Error("BillDesk order ID is missing");
      if (!data.authToken) throw new Error("BillDesk auth token is missing");

      const config = await BillDeskPay(data, billDeskHandler);
      if (!window.loadBillDeskSdk) throw new Error("BillDesk SDK is not loaded");
      window.loadBillDeskSdk(config);
    } catch (err) {
      fail("Could not start the payment. Please try again.", err);
    }
  };

  const handlePay = () => {
    if (paying || !selectedOption) return;
    setPaying(true);
    setError("");
    if (isHttps) handleRealPay();
    else handleFakePay();
  };

  return (
    <div className="mx-auto px-3 py-4" style={{ maxWidth: 480 }}>
      <StepBar current={4} />
      <VastuCard>
        <GoldHeading sub="Secure payment powered by BillDesk">Payment Summary</GoldHeading>

        {!isHttps && (
          <div
            className="rounded-3 p-2 mb-3 small text-center fw-semibold"
            style={{ background: "#FFF3DC", color: C.maroon, border: `1px dashed ${C.gold}` }}
          >
            ⚠️ TEST BUILD — payment is simulated, no real BillDesk call
          </div>
        )}

        <div
          className="rounded-3 p-3 mb-4 small"
          style={{ background: C.sand, border: `1px solid ${C.border}` }}
        >
          {[
            ["Owner", ownerName || "User"],
            ["Plan Type", selectedOption?.label || houseType],
            ["Analysis Fee", `₹${total.toLocaleString()}`],
          ].map(([k, v]) => (
            <div key={k} className="d-flex justify-content-between mb-2">
              <span style={{ color: C.taupe }}>{k}</span>
              <span className="fw-medium">{v}</span>
            </div>
          ))}
        </div>

        <ErrorAlert>{error}</ErrorAlert>

        <PrimaryBtn onClick={handlePay} disabled={paying || !selectedOption} fullWidth variant="gold">
          {paying ? <Spinning>Processing Payment…</Spinning> : `Pay ₹${total.toLocaleString()} →`}
        </PrimaryBtn>
        <p className="small text-center mt-3 mb-0" style={{ color: C.taupe }}>
          🔒 Secured with 256-bit SSL encryption
        </p>
      </VastuCard>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Post Payment ═══════════════════════ */

function StepPostPayment({ onContinue, generating, error }) {
  return (
    <div className="mx-auto px-3 py-4 text-center" style={{ maxWidth: 480 }}>
      <div
        className="rounded-circle mx-auto d-flex align-items-center justify-content-center fs-1 mb-3"
        style={{ width: 80, height: 80, background: "#dcf5e6" }}
      >
        ✅
      </div>
      <h2
        style={{ ...display, fontWeight: 700, color: C.maroon, fontSize: "1.7rem" }}
        className="mb-2"
      >
        Payment Successful!
      </h2>
      <p className="small mb-4" style={{ color: C.taupe }}>
        Your floor plan is ready. Generate your Vastu report now.
      </p>

      <ErrorAlert>{error}</ErrorAlert>

      <button
        onClick={onContinue}
        disabled={generating}
        className="position-relative rounded-4 p-4 text-start border-0 w-100"
        style={{ background: C.maroon, color: "#fff", opacity: generating ? 0.7 : 1 }}
      >
        <div className="fs-3 mb-2">⚡</div>
        <div className="fw-semibold mb-1">
          {generating ? <Spinning>Generating…</Spinning> : "Generate Report Now"}
        </div>
        <div className="small" style={{ color: "#F5C97A" }}>
          Will immediately generate your comprehensive Vastu report
        </div>
      </button>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Generating ═══════════════════════ */

function StepGenerating({ onDone }) {
  const phase = usePhases(GENERATE_PHASES.length, 1000, onDone);

  return (
    <div className="mx-auto px-3 py-5 text-center" style={{ maxWidth: 460 }}>
      <div className="mx-auto mb-4 position-relative" style={{ width: 128, height: 128 }}>
        <div
          className="position-absolute top-0 start-0 w-100 h-100 rounded-circle"
          style={{ background: "#FFF3DC", border: `4px solid ${C.gold}` }}
        />
        <div
          className="position-absolute rounded-circle"
          style={{
            inset: 8,
            border: "2px dashed rgba(123,30,30,.27)",
            animation: "spin 4s linear infinite",
          }}
        />
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center fs-1">
          ✨
        </div>
      </div>
      <h2
        style={{ ...display, fontWeight: 700, color: C.maroon, fontSize: "1.7rem" }}
        className="mb-4"
      >
        Generating Vastu Report
      </h2>
      <div
        className="d-flex flex-column gap-2 text-start mx-auto"
        style={{ maxWidth: 320 }}
      >
        {GENERATE_PHASES.map((item, i) => (
          <div
            key={item}
            className="d-flex align-items-center gap-2 small"
            style={{
              color: i < phase ? C.gold : i === phase ? C.maroon : C.placeholder,
              fontWeight: i === phase ? 600 : 400,
            }}
          >
            <span>{i < phase ? "✓" : i === phase ? "⟳" : "○"}</span>
            {item}
          </div>
        ))}
      </div>
      <style>{"@keyframes spin { to { transform: rotate(360deg); } }"}</style>
    </div>
  );
}

/* ═══════════════════════ REPORT UI ═══════════════════════ */

const BORDER = "#f0b955";

// Mobile: each row becomes a stacked label:value card
function MobileCardList({ columns, dataSource, emptyText }) {
  if (!dataSource || dataSource.length === 0) {
    return (
      <div className="d-md-none small text-center py-2" style={{ color: "#888" }}>
        {emptyText || "No data"}
      </div>
    );
  }
  return (
    <div className="d-md-none d-flex flex-column gap-2">
      {dataSource.map((row) => (
        <div
          key={row.key}
          style={{
            border: `1px solid ${BORDER}`,
            borderRadius: 6,
            padding: "8px 12px",
            background: "#fff",
          }}
        >
          {columns.map((col) => (
            <div
              key={col.key}
              className="d-flex justify-content-between align-items-center py-1"
              style={{ borderBottom: "1px dashed #eee", gap: 12 }}
            >
              <span style={{ fontWeight: 600, fontSize: 12, color: "#666", flexShrink: 0 }}>
                {col.title}
              </span>
              <span style={{ fontSize: 13, textAlign: "right" }}>
                {col.render ? col.render(row[col.dataIndex], row) : (row[col.dataIndex] ?? "-")}
              </span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

// antd Table on desktop (md+), stacked cards on mobile — one column definition drives both
function ResponsiveTable({ columns, dataSource, emptyText }) {
  return (
    <>
      <div className="d-none d-md-block">
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          bordered
          size="middle"
          locale={{ emptyText }}
        />
      </div>
      <MobileCardList columns={columns} dataSource={dataSource} emptyText={emptyText} />
    </>
  );
}

function StatusPill({ ok, label }) {
  const text = label || (ok ? "Good" : "Not Good");
  const good = isGood(text);
  return (
    <span
      style={{
        fontWeight: 700,
        fontSize: 12.5,
        padding: "3px 10px",
        borderRadius: 999,
        color: good ? R.good : R.bad,
        background: good ? R.goodBg : R.badBg,
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
}

const pillColumn = (title, dataIndex) => ({
  title,
  dataIndex,
  key: dataIndex,
  render: (v) => <StatusPill ok={isGood(v)} label={v} />,
});

function SectionNumber({ children }) {
  return (
    <span
      style={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: C.gold,
        color: "#fff",
        fontSize: 12,
        fontWeight: 700,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </span>
  );
}

/* Karpam / Profit & Loss / Yoni / Age badge row */
function AyadiBadgeRow({ house }) {
  const grid = house?.eightGridObj || house?.nineGridObj || {};
  const items = [
    { key: "karpam", label: "Karpam", icon: "❁" },
    { key: "profitLoss", label: "Profit & Loss", icon: "₹" },
    { key: "yoni", label: "Yoni", icon: "🐄" },
    { key: "age", label: "Age Factor", icon: "👤" },
  ];
  return (
    <div className="d-flex flex-wrap gap-4">
      {items.map((it) => {
        const ok = !!grid[it.key];
        return (
          <div key={it.key} className="d-flex align-items-center gap-2">
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 16,
                background: ok ? R.goodBg : R.badBg,
                color: ok ? R.good : R.bad,
              }}
            >
              {it.icon}
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: R.ink }}>{it.label}</div>
              <StatusPill ok={ok} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

function SummaryCard({ index, title, checked, issues, onView, imageSrc }) {
  const hasIssue = issues > 0;
  return (
    <VastuCard style={{ padding: "1.1rem" }}>
      <div className="d-flex align-items-center gap-2 mb-3">
        <SectionNumber>{index}</SectionNumber>
        <span style={{ fontWeight: 700, color: R.ink, fontSize: 15 }}>{title}</span>
      </div>
      <div className="d-flex gap-3">
        <SectionImage src={imageSrc} alt={title} size={84} />
        <div className="flex-grow-1 small" style={{ color: R.ink }}>
          <div className="d-flex justify-content-between py-1">
            <span style={{ color: R.muted }}>{title} Checked</span>
            <span style={{ fontWeight: 700 }}>{checked}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span style={{ color: R.muted }}>Issues Found</span>
            <span style={{ fontWeight: 700, color: hasIssue ? R.bad : R.good }}>{issues}</span>
          </div>
          <div className="d-flex justify-content-between align-items-center py-1">
            <span style={{ color: R.muted }}>Overall Status</span>
            <StatusPill ok={!hasIssue} label={hasIssue ? "Needs Attention" : "Good"} />
          </div>
        </div>
      </div>
      <button
        onClick={onView}
        className="btn btn-link p-0 mt-2 small fw-semibold text-decoration-none"
        style={{ color: C.gold }}
      >
        View {title} Analysis →
      </button>
    </VastuCard>
  );
}

function EntranceRow({ title, value, ok, label, last }) {
  return (
    <div
      className="d-flex justify-content-between align-items-center py-2"
      style={last ? undefined : { borderBottom: "1px solid #F1EAD8" }}
    >
      <div>
        <div style={{ fontWeight: 600, fontSize: 13.5, color: R.ink }}>{title}</div>
        <div className="small" style={{ color: R.muted }}>
          {value || "—"}
        </div>
      </div>
      <StatusPill ok={ok} label={label} />
    </div>
  );
}

const REPORT_TABS = [
  { id: "overview", label: "🏠 Overview" },
  { id: "entrance", label: "🚪 Main Entrance" },
  { id: "rooms", label: "🛏️ Rooms" },
  { id: "windows", label: "🪟 Windows" },
  { id: "leveling", label: "⛰️ Leveling" },
  { id: "misc", label: "📋 Other Factors" },
];

function StepReport({ ownerName, reportData, buildingArea, perimeter, onReview }) {
  const [tab, setTab] = useState("overview");
  const [showIssues, setShowIssues] = useState(false);

  const house = reportData?.house;
  const windowResult = reportData?.window;
  const level = reportData?.level;
  const element = reportData?.element;
  const misc = reportData?.misc;

  const floorEntries = element ? Object.entries(element) : [];
  const allRooms = floorEntries.flatMap(([floorName, rooms]) =>
    (rooms || []).map((r) => ({ ...r, floorName })),
  );

  const miscData = (Array.isArray(misc) ? misc : []).map((m, i) => ({
    key: `misc-${i}`,
    name: m.miscellaneousName ?? m.name ?? m.elementName ?? `Item ${i + 1}`,
    location: m.miscellaneousLocation ?? m.location ?? "",
    result:
      typeof m.miscellaneousLocationResult === "string"
        ? isGood(m.miscellaneousLocationResult)
        : Boolean(m.miscellaneousLocationResult ?? m.result ?? m.status),
  }));

  const levelRows = [
    { key: "sw_ne", name: "SW vs NE", result: !!level?.southWest_Vs_northEast },
    { key: "w_e", name: "W vs E", result: !!level?.west_Vs_east },
    { key: "s_n", name: "S vs N", result: !!level?.south_Vs_north },
  ];

  /* ── flat issue list across all sections ── */
  const issues = [];
  const widthBad = house?.buildingFrontWidthResult && !isGood(house.buildingFrontWidthResult);
  const facingBad = house?.mainDoorFacingResult && !isGood(house.mainDoorFacingResult);
  const placementBad = house && !house.mainDoorPlacementResult;

  if (widthBad)
    issues.push({ section: "Main Entrance", text: `Building Width — ${house.buildingFrontWidthResult}` });
  if (facingBad)
    issues.push({ section: "Main Entrance", text: `Main Facing — ${house.mainDoorFacingResult}` });
  if (placementBad)
    issues.push({ section: "Main Entrance", text: "Door Placement — Unfavorable" });

  allRooms.forEach((r) => {
    if (r.widthStatus && !isGood(r.widthStatus))
      issues.push({ section: "Rooms", text: `${r.elementName || "Room"} — width ${r.widthStatus}` });
    if (r.directionStatus && !isGood(r.directionStatus))
      issues.push({
        section: "Rooms",
        text: `${r.elementName || "Room"} — direction ${r.directionStatus}`,
      });
  });
  if (windowResult && !windowResult.result)
    issues.push({ section: "Windows", text: "Window placement needs correction" });
  levelRows.forEach((l) => {
    if (!l.result) issues.push({ section: "Leveling", text: `${l.name} — Bad` });
  });
  miscData.forEach((m) => {
    if (!m.result) issues.push({ section: "Other Factors", text: `${m.name} — Not Good` });
  });

  const roomIssueCount = allRooms.filter(
    (r) =>
      (r.widthStatus && !isGood(r.widthStatus)) ||
      (r.directionStatus && !isGood(r.directionStatus)),
  ).length;
  const windowIssueCount = windowResult && !windowResult.result ? 1 : 0;
  const miscIssueCount = miscData.filter((m) => !m.result).length;
  const levelIssueCount = levelRows.filter((l) => !l.result).length;
  const entranceHasIssue = Boolean(widthBad || facingBad || placementBad);

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      {/* header */}
      <div style={{ background: R.header, padding: "1.5rem 1.25rem 4.5rem" }}>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div style={{ ...display, fontWeight: 800, fontSize: "1.5rem", color: "#3B2400" }}>
              {ownerName || "Your"}'s Home
            </div>
            <div className="d-flex flex-wrap gap-3 mt-1 small" style={{ color: "#5C3B00" }}>
              <span>📐 Building Area: {buildingArea ?? "—"} sq.ft</span>
              <span>📏 Perimeter: {perimeter ?? "—"} ft</span>
            </div>
          </div>
          {onReview && (
            <button
              onClick={onReview}
              className="btn btn-sm bg-white fw-semibold"
              style={{ borderRadius: 10, color: C.maroon }}
            >
              ⭐ Rate this report
            </button>
          )}
        </div>
      </div>

      <div style={{ margin: "-3.5rem 1.25rem 0" }}>
        <VastuCard>
          <AyadiBadgeRow house={house} />
        </VastuCard>

        {/* key issues banner */}
        <div
          className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 p-3"
          style={{ background: R.warnBg, border: `1px solid ${R.warnBorder}`, borderRadius: 14 }}
        >
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: 20 }}>⚠️</span>
            <div>
              <div style={{ fontWeight: 700, color: R.ink }}>Key Issues Found</div>
              <div className="small" style={{ color: R.muted }}>
                {issues.length} important issue{issues.length !== 1 ? "s" : ""} need your attention.
              </div>
            </div>
          </div>
          <button
            onClick={() => setShowIssues((s) => !s)}
            className="btn btn-sm fw-semibold"
            style={{
              border: `1px solid ${C.gold}`,
              color: C.gold,
              borderRadius: 10,
              background: "#fff",
            }}
          >
            {showIssues ? "Hide Issues" : "View All Issues"} →
          </button>
        </div>

        {showIssues && (
          <div
            className="mt-2 p-3"
            style={{ background: "#fff", border: `1px solid ${C.border}`, borderRadius: 14 }}
          >
            {issues.length === 0 ? (
              <div className="small text-center" style={{ color: R.muted }}>
                No outstanding issues 🎉
              </div>
            ) : (
              <div className="d-flex flex-column gap-2">
                {issues.map((it, i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-between small py-1"
                    style={{ borderBottom: "1px dashed #eee", gap: 12 }}
                  >
                    <span style={{ color: R.muted }}>{it.section}</span>
                    <span style={{ color: R.bad, fontWeight: 600, textAlign: "right" }}>
                      {it.text}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* tabs */}
        <div className="d-flex flex-wrap mt-3" style={{ borderBottom: `1px solid ${C.border}` }}>
          {REPORT_TABS.map((tb) => (
            <button
              key={tb.id}
              onClick={() => setTab(tb.id)}
              className="btn btn-sm border-0 fw-semibold"
              style={{
                color: tab === tb.id ? C.maroon : R.muted,
                borderBottom: tab === tb.id ? `2px solid ${C.gold}` : "2px solid transparent",
                borderRadius: 0,
                padding: "8px 14px",
                background: "transparent",
              }}
            >
              {tb.label}
            </button>
          ))}
        </div>

        <div className="py-3">
          {/* ───── OVERVIEW ───── */}
          {tab === "overview" && (
            <div className="d-flex flex-column gap-3">
              <VastuCard>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <SectionNumber>1</SectionNumber>
                  <span style={{ fontWeight: 700, color: R.ink, fontSize: 15 }}>Main Entrance</span>
                </div>
                <div className="d-flex flex-wrap gap-3">
                  <SectionImage src="/images/main_door.png" alt="Main Door" size={150} />
                  <div className="flex-grow-1" style={{ minWidth: 200 }}>
                    <EntranceRow
                      title="Building Width"
                      value={house?.buildingFrontWidthResult}
                      ok={isGood(house?.buildingFrontWidthResult)}
                      label={house?.buildingFrontWidthResult}
                    />
                    <EntranceRow
                      title="Main Facing"
                      value={house?.mainDoorFacingResult}
                      ok={isGood(house?.mainDoorFacingResult)}
                      label={house?.mainDoorFacingResult}
                    />
                    <EntranceRow
                      title="Door Placement"
                      value={house?.mainDoorPlacementResult ? "Favorable" : "Unfavorable"}
                      ok={!!house?.mainDoorPlacementResult}
                      last
                    />
                  </div>
                  {entranceHasIssue && (
                    <div
                      className="p-3"
                      style={{
                        background: R.warnBg,
                        border: `1px solid ${R.warnBorder}`,
                        borderRadius: 14,
                        minWidth: 220,
                        flex: "1 1 220px",
                      }}
                    >
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <span>💡</span>
                        <span style={{ fontWeight: 700, color: R.ink, fontSize: 13.5 }}>
                          Recommendation
                        </span>
                      </div>
                      <div className="small" style={{ color: R.muted }}>
                        Main door placement or building width is not as per Vastu principles.
                        Consider the suggested corrections.
                      </div>
                      <button
                        onClick={() => setTab("entrance")}
                        className="btn btn-sm mt-2 fw-semibold"
                        style={{ background: C.gold, color: "#fff", borderRadius: 10 }}
                      >
                        View Details →
                      </button>
                    </div>
                  )}
                </div>
              </VastuCard>

              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <SummaryCard
                    index={2}
                    title="Rooms"
                    checked={allRooms.length}
                    issues={roomIssueCount}
                    onView={() => setTab("rooms")}
                    imageSrc="/images/Rooms.png"
                  />
                </div>
                <div className="col-12 col-md-6">
                  <SummaryCard
                    index={3}
                    title="Windows"
                    checked={windowResult ? 1 : 0}
                    issues={windowIssueCount}
                    onView={() => setTab("windows")}
                    imageSrc="/images/window.png"
                  />
                </div>
                <div className="col-12 col-md-6">
                  <SummaryCard
                    index={4}
                    title="Other Factors"
                    checked={miscData.length}
                    issues={miscIssueCount}
                    onView={() => setTab("misc")}
                    imageSrc="/images/misc.png"
                  />
                </div>
                <div className="col-12 col-md-6">
                  <SummaryCard
                    index={5}
                    title="Leveling"
                    checked={levelRows.length}
                    issues={levelIssueCount}
                    onView={() => setTab("leveling")}
                    imageSrc="/images/leveling.png"
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-center gap-2 p-3"
                style={{
                  background: issues.length ? R.warnBg : R.goodBg,
                  border: `1px solid ${issues.length ? R.warnBorder : "#BFE3CC"}`,
                  borderRadius: 14,
                }}
              >
                <CheckCircleFilled
                  style={{ color: issues.length ? "#E39A2A" : R.good, fontSize: 22 }}
                />
                <div>
                  <div style={{ fontWeight: 700, color: R.ink }}>Overall Recommendation</div>
                  <div className="small" style={{ color: R.muted, maxWidth: 520 }}>
                    {issues.length
                      ? "Your building has Vastu imbalances that may affect health, wealth and prosperity. We recommend making the corrections listed above to bring positive energy and harmony."
                      : "Your building shows good Vastu alignment. No corrections are needed."}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ───── MAIN ENTRANCE ───── */}
          {tab === "entrance" && (
            <VastuCard>
              <div className="d-flex flex-wrap gap-4">
                <SectionImage src="/images/main_door.png" alt="Main Door" size={200} />
                <div className="flex-grow-1">
                  <ResponsiveTable
                    columns={[
                      pillColumn("Building Width", "width"),
                      pillColumn("Main Facing", "facing"),
                      {
                        title: "Door Placement",
                        dataIndex: "placement",
                        key: "placement",
                        render: (v) => <StatusPill ok={!!v} />,
                      },
                    ]}
                    dataSource={[
                      {
                        key: "main-door",
                        width: house?.buildingFrontWidthResult,
                        facing: house?.mainDoorFacingResult,
                        placement: house?.mainDoorPlacementResult,
                      },
                    ]}
                  />
                </div>
              </div>
            </VastuCard>
          )}

          {/* ───── ROOMS ───── */}
          {tab === "rooms" && (
            <div className="d-flex flex-column gap-3">
              {floorEntries.length === 0 && (
                <VastuCard>
                  <div className="small text-center" style={{ color: R.muted }}>
                    No room data available
                  </div>
                </VastuCard>
              )}
              {floorEntries.map(([floorName, rooms]) => (
                <VastuCard key={floorName} style={{ padding: 0, overflow: "hidden" }}>
                  <div
                    style={{
                      background: C.gold,
                      color: "#fff",
                      fontWeight: 700,
                      padding: "10px 16px",
                    }}
                  >
                    {formatFloorName(floorName)}
                  </div>
                  <div className="p-3">
                    <ResponsiveTable
                      columns={[
                        { title: "Element", dataIndex: "elementName", key: "elementName" },
                        { title: "Width", dataIndex: "roomWidth", key: "roomWidth" },
                        pillColumn("Width Status", "widthStatus"),
                        { title: "Direction", dataIndex: "directionName", key: "directionName" },
                        pillColumn("Direction Status", "directionStatus"),
                      ]}
                      dataSource={(rooms || []).map((r, i) => ({ key: `${floorName}-${i}`, ...r }))}
                    />
                  </div>
                </VastuCard>
              ))}
            </div>
          )}

          {/* ───── WINDOWS ───── */}
          {tab === "windows" && (
            <VastuCard>
              <div className="d-flex flex-wrap gap-4 align-items-center">
                <SectionImage src="/images/window.png" alt="Windows" size={200} />
                <div className="flex-grow-1">
                  <div
                    className="d-flex justify-content-between align-items-center py-2"
                    style={{ borderBottom: "1px solid #F1EAD8" }}
                  >
                    <span style={{ color: R.muted }}>Overall Window Result</span>
                    <StatusPill ok={!!windowResult?.result} />
                  </div>
                  {!windowResult?.result && (
                    <div
                      className="p-3 mt-2"
                      style={{
                        background: R.warnBg,
                        border: `1px solid ${R.warnBorder}`,
                        borderRadius: 12,
                      }}
                    >
                      <div className="small" style={{ color: R.muted }}>
                        Window placement is not as per Vastu principles for this direction.
                        Consider relocating or adding a remedy such as a Vastu pyramid near the
                        affected window.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </VastuCard>
          )}

          {/* ───── LEVELING ───── */}
          {tab === "leveling" && (
            <VastuCard>
              <div className="d-flex flex-wrap gap-4">
                <SectionImage src="/images/leveling.png" alt="Leveling" size={150} />
                <div className="flex-grow-1">
                  <ResponsiveTable
                    columns={[
                      { title: "Direction", dataIndex: "name", key: "name" },
                      {
                        title: "Status",
                        dataIndex: "result",
                        key: "result",
                        render: (v) => <StatusPill ok={v} />,
                      },
                    ]}
                    dataSource={levelRows}
                  />
                  <div className="d-flex justify-content-between align-items-center mt-2 small">
                    <span style={{ color: R.muted }}>Overall Leveling</span>
                    <StatusPill ok={!!level?.result} />
                  </div>
                </div>
              </div>
            </VastuCard>
          )}

          {/* ───── OTHER FACTORS ───── */}
          {tab === "misc" && (
            <VastuCard>
              <div className="d-flex flex-wrap gap-4">
                <SectionImage src="/images/misc.png" alt="Other Factors" size={150} />
                <div className="flex-grow-1">
                  <ResponsiveTable
                    columns={[
                      { title: "Item", dataIndex: "name", key: "name" },
                      { title: "Location", dataIndex: "location", key: "location" },
                      {
                        title: "Result",
                        dataIndex: "result",
                        key: "result",
                        render: (v) => <StatusPill ok={v} />,
                      },
                    ]}
                    dataSource={miscData}
                    emptyText="No miscellaneous items"
                  />
                </div>
              </div>
            </VastuCard>
          )}
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════ SCREEN — Feedback ═══════════════════════ */

function StepFeedback({ onDone, onBack }) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // TODO: send { rating, feedback } to your backend here.
  const submit = () => setSubmitted(true);

  if (submitted) {
    return (
      <div className="mx-auto px-3 py-5 text-center" style={{ maxWidth: 460 }}>
        <div className="fs-1 mb-3">🙏</div>
        <h2 style={{ ...display, fontWeight: 700, color: C.maroon }} className="fs-2 mb-2">
          Dhanyavaad!
        </h2>
        <p className="small mb-4" style={{ color: C.taupe }}>
          Thank you for your valuable feedback
        </p>
        <PrimaryBtn onClick={onDone} variant="gold">
          Back to Home
        </PrimaryBtn>
      </div>
    );
  }

  return (
    <div className="mx-auto px-3 py-4" style={{ maxWidth: 460 }}>
      <BackButton onClick={onBack} />
      <VastuCard style={{ textAlign: "center" }}>
        <div className="fs-2 mb-2">⭐</div>
        <GoldHeading sub="Your feedback helps us improve our Vastu analysis">
          Rate Your Experience
        </GoldHeading>
        <div className="d-flex justify-content-center mb-4">
          <Rate value={rating} onChange={setRating} style={{ fontSize: 36, color: C.gold }} />
        </div>
        <div className="text-start mb-4">
          <label style={{ ...labelStyle, display: "block", marginBottom: 4 }}>Your Feedback</label>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
            placeholder="Share your experience with our Vastu analysis…"
            className="w-100"
            style={{ ...inputStyle, resize: "none" }}
          />
        </div>
        <PrimaryBtn onClick={submit} disabled={!rating} fullWidth variant="gold">
          Submit Feedback
        </PrimaryBtn>
      </VastuCard>
    </div>
  );
}

/* ═══════════════════════ ROOT — HomeVastuFlow ═══════════════════════ */

export default function HomeVastuFlow({ onExit }) {
  const [step, setStep] = useState("details");
  const [details, setDetails] = useState({});
  const [ocrResult, setOcrResult] = useState(null);
  const [houseType, setHouseType] = useState(null);
  const [prefillLagna, setPrefillLagna] = useState("");
  const [pricing, setPricing] = useState({ options: [] });

  const [reportData, setReportData] = useState(null);
  const [reportError, setReportError] = useState("");
  const [generatingReport, setGeneratingReport] = useState(false);

  const go = (s) => setStep(s);

  /* pricing */
  useEffect(() => {
    const token = window.sessionStorage.getItem("token");
    (async () => {
      try {
        const res = await vasthuUrl.get(`/api/vastu-pricing/type/HOUSE`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const rows = Array.isArray(res.data) ? res.data : res.data?.data || [];
        const options = rows
          .filter((r) => r.isActive)
          .map((r) => ({
            id: r.id, // plan reference for the payment API
            key: r.subType,
            label: r.label,
            price: r.minPrice,
            maxPrice: r.maxPrice,
            scope: r.scope,
            isCustomQuote: r.priceUnit === "ON_REQUEST",
          }));
        setPricing({ options });
      } catch (err) {
        console.error("Pricing fetch error:", err);
      }
    })();
  }, []);

  /* report */
  const handleGenerateReport = async (payload) => {
    const token = window.sessionStorage.getItem("token");
    setGeneratingReport(true);
    setReportError("");
    try {
      const res = await vasthuUrl.post(`/ocr/generateReport`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setReportData(res.data?.body);
      go("generating"); // cosmetic animation, then the report
    } catch (err) {
      console.error("Generate report error:", err);
      setReportError(
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to generate report. Please try again.",
      );
    } finally {
      setGeneratingReport(false);
    }
  };

  /* lagna */
  const handleLagnaOpen = (currentDetails) => {
    setDetails(currentDetails); // keep what the user already typed
    go("lagna");
  };

  const handleLagnaDone = (lagna) => {
    const matched = LAGNA_OPTIONS.find((o) =>
      o.label.toLowerCase().includes(String(lagna).toLowerCase()),
    );
    setPrefillLagna(matched ? matched.value : "");
    go("details");
  };

  /* upload → scanning */
  const handleUploadDone = (ocrData, selectedHouseType) => {
    const merged = {
      ...ocrData?.data,
      houseDetails: {
        ...ocrData?.data?.houseDetails,
        building_front_width:
          Number(details?.hFacingWidth) || ocrData?.data?.houseDetails?.building_front_width,
      },
    };

    // If the plan has a different floor count than the selected type, bill for the detected one
    const floorCount = merged?.elementDetails?.floorDetails?.length;
    const detectedOption = pricing.options.find(
      (o) => getFloorCountFromLabel(o.label) === floorCount,
    );

    setOcrResult(merged);
    setHouseType(detectedOption ? detectedOption.key : selectedHouseType);
    go("scanning");
  };

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      {step === "lagna" && <StepLagna onBack={() => go("details")} onDone={handleLagnaDone} />}

      {step === "details" && (
        <StepDetails
          onNext={(data) => {
            setDetails(data);
            go("upload");
          }}
          onLagna={handleLagnaOpen}
          prefillLagna={prefillLagna}
          initialDetails={details}
        />
      )}

      {step === "upload" && (
        <StepUpload
          onNext={handleUploadDone}
          onBack={() => go("details")}
          pricing={pricing}
          details={details}
        />
      )}

      {step === "scanning" && <StepScanning onDone={() => go("payment")} />}

      {step === "payment" && (
        <StepPayment
          houseType={houseType}
          ownerName={details.ownerName || ""}
          onPay={() => go("post-payment")}
          pricing={pricing}
        />
      )}

      {step === "post-payment" && (
        <StepPostPayment
          onContinue={() => handleGenerateReport(ocrResult)}
          generating={generatingReport}
          error={reportError}
        />
      )}

      {step === "generating" && <StepGenerating onDone={() => go("report")} />}

      {step === "report" && (
        <StepReport
          ownerName={details.ownerName || "Your"}
          reportData={reportData}
          buildingArea={ocrResult?.houseDetails?.building_area}
          perimeter={ocrResult?.houseDetails?.perimeter}
          onReview={() => go("feedback")}
        />
      )}

      {step === "feedback" && (
        <StepFeedback
          onBack={() => go("report")}
          onDone={() => (onExit ? onExit() : go("details"))}
        />
      )}
    </div>
  );
}